// import React, { useEffect, useMemo, useRef, useState } from "react";
// import axios from "axios";

// import { BANK_DETAILS, USD_TO_EUR_RATE } from "./constants/eventData";
// import "./PaymentView.css";
// import { toastSuccess, toastError } from "../Services/toaster";

// const USD_TO_VND_RATE = 26000;

// // Safety cap on manual re-checks only (each click of "Check Status
// // Now" / "Check Again" is a deliberate user action, not automatic
// // polling — this just stops someone from clicking it 500 times).
// const MAX_MANUAL_STATUS_CHECKS = 20;

// // How often we check whether the user closed the VNPay popup window.
// // This is a LOCAL check of window.closed — it is not an API call —
// // so it can run frequently without violating "only one API call".
// // const POPUP_WATCH_INTERVAL_MS = 500;
// //
// /*
//  * ============================================================
//  * WHY YOU SEE RAW JSON INSTEAD OF THE APP'S POPUP
//  * ============================================================
//  *
//  * VNPay redirects the popup window directly to your BACKEND'S
//  * /api/vnpay/return endpoint. That endpoint currently responds with
//  * raw JSON -- {"success":true,...} -- which the browser just displays
//  * as a plain page inside the popup.
//  *
//  * Once that popup navigates to a different origin than this app,
//  * the browser's Same-Origin Policy blocks our JavaScript from
//  * reading ANYTHING inside it -- its URL, its content, nothing. This
//  * isn't something the frontend can work around; only the backend
//  * can fix it, in one of two ways:
//  *
//  *   A) Make /api/vnpay/return respond with a tiny HTML page instead
//  *      of raw JSON, that does:
//  *
//  *        <script>
//  *          if (window.opener) {
//  *            window.opener.postMessage(
//  *              { source: "vnpay_return", payload: <the JSON> },
//  *              "https://YOUR-FRONTEND-ORIGIN"
//  *            );
//  *          }
//  *          window.close();
//  *        </script>
//  *
//  *      This is the standard pattern every payment-gateway popup
//  *      integration uses. The listener below is already wired up to
//  *      receive this -- if the backend adds it, the result appears in
//  *      this app INSTANTLY, with zero extra API calls, and the popup
//  *      closes itself so the raw JSON is never visible.
//  *
//  *   B) Redirect (not just respond) to a URL on THIS app's own domain
//  *      after validating the payment, e.g.
//  *      https://yourapp.com/payment/return?order_id=...&status=...
//  *
//  * Until one of those ships, the best this frontend can do is: watch
//  * for the popup being closed (a same-origin-safe check -- just reads
//  * window.closed, no content access needed) and make exactly ONE
//  * check-status call at that point, instead of polling repeatedly.
//  * ============================================================
//  */

// const PaymentView = ({
//   registration = {},
//   event = {},

//   paymentMethod,
//   setPaymentMethod,

//   isPaying = false,
//   paymentConfirmed = false,
//   error = "",

//   handlePayPalPayment,
//   handleBankTransferConfirm,

//   getTotalUSD,

//   onBack,
//   onPaymentSuccess,
// }) => {
//   const API_URL = process.env.REACT_APP_API_URL;

//   const [vnpayLoading, setVnpayLoading] = useState(false);
//   const [vnpayError, setVnpayError] = useState("");
//   const [vnpaySuccess, setVnpaySuccess] = useState(false);
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [paymentResult, setPaymentResult] = useState(null); // "success" | "rejected" | null
//   const [canRecheckStatus, setCanRecheckStatus] = useState(false);

//   const popupRef = useRef(null);
//   const checkingStatusRef = useRef(false);
//   const manualCheckCountRef = useRef(0);
//   const statusCheckTxnRef = useRef(null);
//   const popupWatchIntervalRef = useRef(null);
//   //
//   /*
//    * ============================================================
//    * NORMALIZE REGISTRATION DATA
//    * ============================================================
//    */
//   const registrationData = useMemo(() => {
//     if (!registration) {
//       return {};
//     }

//     if (Array.isArray(registration)) {
//       return registration[0] || {};
//     }

//     if (Array.isArray(registration.registrations)) {
//       return registration.registrations[0] || {};
//     }

//     if (registration.registration) {
//       return registration.registration;
//     }

//     return registration;
//   }, [registration]);

//   useEffect(() => {
//     console.log("========== PAYMENT VIEW ==========");
//     console.log("Original registration:", registration);
//     console.log("Normalized registration:", registrationData);
//     console.log("Event:", event);
//     console.log("==================================");
//   }, [registration, registrationData, event]);

//   /*
//    * ============================================================
//    * REGISTRATION INFORMATION
//    * ============================================================
//    */

//   const registrationId =
//     registrationData?.id !== undefined &&
//     registrationData?.id !== null &&
//     registrationData?.id !== ""
//       ? registrationData.id
//       : null;

//   const orderId =
//     registrationData?.order_id !== undefined &&
//     registrationData?.order_id !== null &&
//     registrationData?.order_id !== ""
//       ? String(registrationData.order_id)
//       : "";

//   const eventId =
//     registrationData?.event_id || event?.id || event?.event_id || null;

//   const title = registrationData?.title || "";
//   const firstName =
//     registrationData?.first_name || registrationData?.firstName || "";
//   const lastName =
//     registrationData?.last_name || registrationData?.lastName || "";
//   const email = registrationData?.email || "";
//   const phone = registrationData?.phone || "";
//   const nationality = registrationData?.nationality || "";
//   const dietaryPreference = registrationData?.dietary_preference || "";
//   const dietaryInformation = registrationData?.dietary_information || "";
//   const additionalInformation = registrationData?.additional_information || "";
//   const remarks = registrationData?.remarks || "";

//   const isMember =
//     registrationData?.is_member === true || registrationData?.is_member === 1;

//   const currency = registrationData?.currency || "USD";
//   const currencyUpper = String(currency).trim().toUpperCase();

//   const paymentStatus = String(
//     registrationData?.payment_status || "PENDING",
//   ).toUpperCase();

//   const orderStatus = String(
//     registrationData?.order_status || "ACTIVE",
//   ).toUpperCase();

//   /*
//    * ============================================================
//    * EVENT INFORMATION
//    * ============================================================
//    */

//   const eventTitle =
//     event?.event_title || event?.title || event?.name || "Event Registration";
//   const eventDate = event?.event_date || event?.date || "";
//   const checkinTime = event?.checkin_time || event?.checkinTime || "";
//   const venue = event?.venue || "";
//   const venueCity = event?.venue_city || event?.venueCity || "";

//   /*
//    * ============================================================
//    * PAYMENT AMOUNT -- CURRENCY-AWARE
//    * ============================================================
//    */

//   const rawPrice = registrationData?.price;

//   const hasRegistrationPrice =
//     rawPrice !== undefined &&
//     rawPrice !== null &&
//     rawPrice !== "" &&
//     Number.isFinite(Number(rawPrice));

//   const rawAmount = hasRegistrationPrice ? Number(rawPrice) : null;

//   const totalUSD = useMemo(() => {
//     if (rawAmount !== null) {
//       if (currencyUpper === "VND") {
//         return rawAmount / USD_TO_VND_RATE;
//       }
//       return rawAmount;
//     }

//     if (typeof getTotalUSD === "function") {
//       const parentAmount = Number(getTotalUSD());
//       if (Number.isFinite(parentAmount)) {
//         return parentAmount;
//       }
//     }

//     return null;
//   }, [rawAmount, currencyUpper, getTotalUSD]);

//   const hasValidPaymentAmount =
//     totalUSD !== null && Number.isFinite(totalUSD) && totalUSD >= 0;

//   const isFreeRegistration = hasValidPaymentAmount && totalUSD === 0;
//   const isPaymentAmountMissing = totalUSD === null;

//   const totalEUR = useMemo(() => {
//     if (!hasValidPaymentAmount) {
//       return "0.00";
//     }
//     return (totalUSD * USD_TO_EUR_RATE).toFixed(2);
//   }, [totalUSD, hasValidPaymentAmount]);

//   const totalVND = useMemo(() => {
//     if (!hasValidPaymentAmount) {
//       return 0;
//     }

//     if (currencyUpper === "VND" && rawAmount !== null) {
//       return Math.round(rawAmount);
//     }

//     return Math.round(totalUSD * USD_TO_VND_RATE);
//   }, [totalUSD, hasValidPaymentAmount, currencyUpper, rawAmount]);

//   const priceLabel = isMember ? "Member" : "Guest";

//   const isAlreadyPaid =
//     paymentStatus === "PAID" ||
//     paymentStatus === "SUCCESS" ||
//     paymentStatus === "SUCCESSFUL" ||
//     paymentStatus === "COMPLETED";

//   const methods = [
//     { id: "vnpay", name: "VNPAY", sub: "ATM · QR · Banking" },
//     { id: "paypal", name: "PayPal", sub: "Card / PayPal balance" },
//     { id: "bank", name: "Bank Transfer", sub: "USD / EUR wire" },
//   ];

//   /*
//    * ============================================================
//    * CLEANUP
//    * ============================================================
//    */

//   const stopStatusChecking = () => {
//     if (popupWatchIntervalRef.current) {
//       clearInterval(popupWatchIntervalRef.current);
//       popupWatchIntervalRef.current = null;
//     }

//     checkingStatusRef.current = false;
//     manualCheckCountRef.current = 0;
//     statusCheckTxnRef.current = null;
//   };

//   const closeVNPayPopup = () => {
//     if (popupRef.current && !popupRef.current.closed) {
//       popupRef.current.close();
//     }
//     popupRef.current = null;
//   };

//   useEffect(() => {
//     return () => {
//       stopStatusChecking();
//       closeVNPayPopup();
//     };
//   }, []);

//   /*
//    * ============================================================
//    * PAYMENT RESULT HELPERS -- shared by the (single) API check AND
//    * the postMessage listener, so both paths apply the result the
//    * same way.
//    * ============================================================
//    */

//   const getPaymentStatus = (data) => {
//     return String(
//       data?.status ||
//         data?.payment_status ||
//         data?.transaction_status ||
//         data?.paymentStatus ||
//         data?.data?.status ||
//         data?.data?.payment_status ||
//         data?.data?.transaction_status ||
//         "",
//     ).toLowerCase();
//   };

//   const isPaymentSuccessful = (data) => {
//     const status = getPaymentStatus(data);
//     return (
//       data?.success === true ||
//       data?.paid === true ||
//       data?.payment_success === true ||
//       data?.data?.success === true ||
//       data?.data?.paid === true ||
//       data?.data?.payment_success === true ||
//       ["success", "successful", "paid", "completed", "complete"].includes(
//         status,
//       )
//     );
//   };

//   const isPaymentFailed = (data) => {
//     const status = getPaymentStatus(data);
//     return [
//       "failed",
//       "failure",
//       "rejected",
//       "cancelled",
//       "canceled",
//       "error",
//     ].includes(status);
//   };

//   const applySuccessResult = (data) => {
//     stopStatusChecking();
//     closeVNPayPopup();

//     setVnpayLoading(false);
//     setVnpaySuccess(true);
//     setVnpayError("");
//     setCanRecheckStatus(false);

//     setPaymentResult("success");
//     setShowSuccessPopup(true);

//     toastSuccess("Payment completed successfully!");

//     console.log("VNPay SUCCESS:", data);
//   };

//   const applyRejectedResult = (data) => {
//     const message =
//       data?.message || data?.detail || "Payment was rejected or failed.";
//     const cleanMessage =
//       typeof message === "string" ? message : "Payment was rejected or failed.";

//     stopStatusChecking();
//     closeVNPayPopup();

//     setVnpayLoading(false);
//     setVnpaySuccess(false);
//     setVnpayError(cleanMessage);
//     setCanRecheckStatus(false);

//     setPaymentResult("rejected");
//     setShowSuccessPopup(true);

//     toastError(cleanMessage);

//     console.log("VNPay REJECTED:", data);
//   };

//   /*
//    * ============================================================
//    * POSTMESSAGE LISTENER (instant path)
//    * ============================================================
//    * If the backend's /api/vnpay/return page is ever updated to
//    * postMessage its result (see note above), this fires immediately
//    * -- no API call needed at all, since the payload already IS the
//    * check-status-shaped JSON.
//    */
//   /*
//    * ============================================================
//    * VNPAY RETURN MESSAGE
//    * ============================================================
//    *
//    * VNPay redirects the PAYMENT POPUP to:
//    *
//    *   /api/vnpay/return
//    *
//    * Backend return endpoint sends:
//    *
//    *   window.opener.postMessage(...)
//    *
//    * This listener receives that event.
//    *
//    * IMPORTANT:
//    * We call check-status ONLY ONCE after VNPay returns.
//    * We do NOT wait for the popup to close.
//    * We do NOT poll.
//    */
//   useEffect(() => {
//     const handleMessage = (evt) => {
//       if (!evt?.data || evt.data.source !== "vnpay_return") {
//         return;
//       }

//       console.log("VNPay return message received:", evt.data);

//       /*
//        * Security check.
//        */
//       if (API_URL) {
//         try {
//           const backendOrigin = new URL(API_URL).origin;

//           if (evt.origin !== backendOrigin) {
//             console.warn(
//               "Ignoring VNPay message from unexpected origin:",
//               evt.origin,
//             );
//             return;
//           }
//         } catch (err) {
//           console.warn("Could not validate API origin:", err);
//         }
//       }

//       const payload = evt.data.payload || {};

//       /*
//        * txn_ref can come directly from the return response.
//        */
//       const txnRef =
//         payload?.txn_ref ||
//         payload?.data?.txn_ref ||
//         evt.data?.txn_ref ||
//         evt.data?.data?.txn_ref ||
//         null;

//       console.log("VNPay return txn_ref:", txnRef);

//       if (!txnRef) {
//         console.error("VNPay return did not contain txn_ref:", payload);

//         setVnpayLoading(false);
//         setVnpayError(
//           "VNPay returned successfully, but the transaction reference is missing.",
//         );

//         return;
//       }

//       /*
//        * Save the transaction reference.
//        */
//       statusCheckTxnRef.current = txnRef;

//       /*
//        * IMPORTANT:
//        * The return page has opened.
//        *
//        * NOW call check-status exactly once.
//        */
//       setVnpayLoading(true);
//       setVnpayError("");
//       setCanRecheckStatus(false);

//       checkVNPayStatus(txnRef);
//     };

//     window.addEventListener("message", handleMessage);

//     return () => {
//       window.removeEventListener("message", handleMessage);
//     };

//     // checkVNPayStatus is intentionally excluded because it is a
//     // stable function for this component flow.
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [API_URL]);

//   /*
//    * ============================================================
//    * SINGLE CHECK-STATUS CALL
//    * ============================================================
//    * Exactly one request per invocation -- no self-rescheduling, no
//    * interval. Called from exactly two places: (1) once, when the
//    * popup is detected closed, and (2) on demand when the user clicks
//    * "Check Status Now" / "Check Again".
//    */

//   const checkVNPayStatus = async (txnRef) => {
//     if (!txnRef) {
//       console.error("VNPay status check skipped: txn_ref is missing.");
//       return;
//     }

//     if (checkingStatusRef.current) {
//       return;
//     }

//     checkingStatusRef.current = true;

//     try {
//       const response = await axios.get(`${API_URL}/api/vnpay/check-status`, {
//         params: { txn_ref: txnRef },
//       });

//       const data = response.data;
//       console.log("VNPay status check (single call):", data);

//       if (isPaymentSuccessful(data)) {
//         applySuccessResult(data);
//         return;
//       }

//       if (isPaymentFailed(data)) {
//         applyRejectedResult(data);
//         return;
//       }

//       // Inconclusive -- do NOT auto-retry. Surface it and let the
//       // user decide (manual "Check Again", or try paying again).
//       setVnpayLoading(false);
//       setCanRecheckStatus(true);
//       setVnpayError(
//         "We couldn't confirm your payment yet. If you completed it in the VNPay window, click Check Again in a moment.",
//       );
//     } catch (err) {
//       console.error("VNPay Status Check Error:", err?.response?.data || err);

//       setVnpayLoading(false);
//       setCanRecheckStatus(true);
//       setVnpayError(
//         "We couldn't reach the payment status service. Click Check Again to retry.",
//       );
//     } finally {
//       checkingStatusRef.current = false;
//     }
//   };

//   const startStatusChecking = (txnRef) => {
//     /*
//      * We do NOT check payment status here.
//      *
//      * We wait for VNPay to redirect the popup to
//      * /api/vnpay/return.
//      *
//      * The backend return page sends postMessage().
//      *
//      * The postMessage listener then calls checkVNPayStatus()
//      * exactly once.
//      */
//     statusCheckTxnRef.current = txnRef;
//     manualCheckCountRef.current = 0;
//   };

//   const handleManualStatusCheck = () => {
//     const txnRef = statusCheckTxnRef.current;
//     if (!txnRef) return;

//     if (manualCheckCountRef.current >= MAX_MANUAL_STATUS_CHECKS) {
//       toastError(
//         "Please contact support with your Order ID -- we couldn't confirm this payment automatically.",
//       );
//       return;
//     }

//     manualCheckCountRef.current += 1;
//     setVnpayLoading(true);
//     setCanRecheckStatus(false);
//     checkVNPayStatus(txnRef);
//   };

//   /*
//    * ============================================================
//    * BACK
//    * ============================================================
//    */

//   const handleBack = () => {
//     stopStatusChecking();
//     closeVNPayPopup();

//     if (onBack) {
//       onBack();
//       return;
//     }

//     window.history.back();
//   };

//   /*
//    * ============================================================
//    * DOWNLOAD INVOICE
//    * ============================================================
//    */

//   const handleDownloadInvoice = async () => {
//     if (!orderId) {
//       toastError("Order ID is missing.");
//       return;
//     }

//     try {
//       const response = await axios.get(`${API_URL}/api/invoices/${orderId}`, {
//         responseType: "blob",
//       });

//       const blob = new Blob([response.data], { type: "application/pdf" });
//       const url = window.URL.createObjectURL(blob);

//       const link = document.createElement("a");
//       link.href = url;
//       link.download = `Invoice-${orderId}.pdf`;

//       document.body.appendChild(link);
//       link.click();
//       link.remove();

//       window.URL.revokeObjectURL(url);

//       toastSuccess("Invoice downloaded successfully.");
//     } catch (err) {
//       console.error("Invoice download error:", err?.response?.data || err);
//       toastError("Unable to download invoice.");
//     }
//   };

//   /*
//    * ============================================================
//    * CONTINUE AFTER SUCCESSFUL / FREE PAYMENT
//    * ============================================================
//    */

//   const handleContinueAfterPayment = () => {
//     setShowSuccessPopup(false);

//     stopStatusChecking();
//     closeVNPayPopup();

//     if (onPaymentSuccess) {
//       onPaymentSuccess({
//         registration: registrationData,
//         registrationId,
//         eventId,
//         orderId,
//         amount: totalUSD,
//         currency,
//         paymentStatus: isFreeRegistration ? "FREE" : "PAID",
//       });
//       return;
//     }

//     if (onBack) {
//       onBack();
//       return;
//     }

//     window.history.back();
//   };

//   /*
//    * ============================================================
//    * CLOSE WITHOUT CONTINUING
//    * ============================================================
//    * Used for the "×" button and the rejected-payment Close action.
//    * Never calls onPaymentSuccess -- just dismisses and lets the user
//    * try again from the payment method screen.
//    */

//   const handleClosePaymentPopup = () => {
//     setShowSuccessPopup(false);

//     stopStatusChecking();
//     closeVNPayPopup();

//     setVnpayLoading(false);
//     setCanRecheckStatus(false);
//   };

//   /*
//    * ============================================================
//    * VNPAY PAYMENT
//    * ============================================================
//    */

//   const handleVNPayPayment = async () => {
//     if (!registrationData || Object.keys(registrationData).length === 0) {
//       const message =
//         "Registration information is missing. Please go back and register again.";
//       setVnpayError(message);
//       toastError(message);
//       return;
//     }

//     if (!orderId) {
//       const message =
//         "Order ID is missing from the registration. Please register again.";
//       setVnpayError(message);
//       toastError(message);
//       console.error(
//         "VNPay payment stopped: order_id missing.",
//         registrationData,
//       );
//       return;
//     }

//     if (isPaymentAmountMissing) {
//       const message =
//         "Registration amount is missing. Please check the registration details.";
//       setVnpayError(message);
//       toastError(message);
//       return;
//     }

//     if (isFreeRegistration) {
//       const message = "This registration is free. No payment is required.";
//       setVnpayError(message);
//       toastError(message);
//       return;
//     }

//     if (!totalVND || totalVND <= 0) {
//       const message = "VNPay payment amount is invalid.";
//       setVnpayError(message);
//       toastError(message);
//       return;
//     }

//     const width = 500;
//     const height = 750;
//     const left = window.screenX + (window.outerWidth - width) / 2;
//     const top = window.screenY + (window.outerHeight - height) / 2;

//     const paymentPopup = window.open(
//       "",
//       "vnpay_payment",
//       `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
//     );

//     if (!paymentPopup) {
//       const message =
//         "Payment popup was blocked. Please allow popups and try again.";
//       setVnpayError(message);
//       toastError(message);
//       return;
//     }

//     popupRef.current = paymentPopup;

//     try {
//       setVnpayLoading(true);
//       setVnpayError("");
//       setVnpaySuccess(false);
//       setCanRecheckStatus(false);

//       const paymentPayload = { amount: totalVND, order_id: orderId };

//       console.log("========== CREATE VNPAY PAYMENT ==========");
//       console.log({
//         registrationId,
//         eventId,
//         orderId,
//         currencyFromBackend: currency,
//         amountUSD: totalUSD,
//         amountVND: totalVND,
//         paymentPayload,
//       });
//       console.log("===========================================");

//       const response = await axios.post(
//         `${API_URL}/api/vnpay/create-payment`,
//         paymentPayload,
//         {
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//           },
//         },
//       );

//       const data = response.data;
//       console.log("VNPay create-payment response:", data);

//       if (!data?.success || !data?.payment_url) {
//         closeVNPayPopup();
//         const message =
//           data?.message ||
//           data?.detail ||
//           "Unable to create VNPay payment. Please try again.";
//         const cleanMessage =
//           typeof message === "string"
//             ? message
//             : "Unable to create VNPay payment. Please try again.";

//         setVnpayError(cleanMessage);
//         toastError(cleanMessage);
//         setVnpayLoading(false);
//         return;
//       }

//       const txnRef = data?.txn_ref || data?.data?.txn_ref || null;

//       if (!txnRef) {
//         closeVNPayPopup();
//         const message =
//           "VNPay transaction reference is missing. Please try again.";
//         setVnpayError(message);
//         toastError(message);
//         setVnpayLoading(false);
//         console.error(
//           "VNPay create-payment response does not contain txn_ref:",
//           data,
//         );
//         return;
//       }

//       console.log("VNPay txn_ref:", txnRef);

//       paymentPopup.location.href = data.payment_url;

//       startStatusChecking(txnRef);
//     } catch (err) {
//       console.error("VNPay Payment Error:", err?.response?.data || err);

//       closeVNPayPopup();
//       stopStatusChecking();

//       const errorMessage =
//         err?.response?.data?.detail?.[0]?.msg ||
//         err?.response?.data?.detail?.message ||
//         err?.response?.data?.detail ||
//         err?.response?.data?.message ||
//         "Failed to create VNPay payment. Please try again.";

//       const message =
//         typeof errorMessage === "string"
//           ? errorMessage
//           : "Failed to create VNPay payment. Please try again.";

//       setVnpayError(message);
//       toastError(message);
//       setVnpayLoading(false);
//     }
//   };

//   /*
//    * ============================================================
//    * PAYPAL
//    * ============================================================
//    */

//   const handlePayPalClick = () => {
//     if (!orderId) {
//       toastError("Order ID is missing. Please register again.");
//       return;
//     }
//     if (isPaymentAmountMissing) {
//       toastError("Registration amount is missing.");
//       return;
//     }
//     if (isFreeRegistration) {
//       setPaymentResult("success");
//       setShowSuccessPopup(true);
//       return;
//     }
//     if (typeof handlePayPalPayment !== "function") {
//       toastError("PayPal payment is not configured.");
//       return;
//     }

//     handlePayPalPayment({
//       orderId,
//       registrationId,
//       eventId,
//       amount: totalUSD,
//       currency,
//       registration: registrationData,
//     });
//   };

//   /*
//    * ============================================================
//    * BANK TRANSFER
//    * ============================================================
//    */

//   const handleBankClick = () => {
//     if (!orderId) {
//       toastError("Order ID is missing. Please register again.");
//       return;
//     }
//     if (isPaymentAmountMissing) {
//       toastError("Registration amount is missing.");
//       return;
//     }
//     if (typeof handleBankTransferConfirm !== "function") {
//       toastError("Bank transfer payment is not configured.");
//       return;
//     }

//     handleBankTransferConfirm({
//       orderId,
//       registrationId,
//       eventId,
//       amount: totalUSD,
//       currency,
//       registration: registrationData,
//     });
//   };

//   /*
//    * ============================================================
//    * REGISTRATION VALIDATION
//    * ============================================================
//    */

//   const hasRegistrationData =
//     registrationData &&
//     typeof registrationData === "object" &&
//     !Array.isArray(registrationData) &&
//     Object.keys(registrationData).length > 0;

//   if (!hasRegistrationData) {
//     return (
//       <div className="er-payment-view">
//         <div className="er-page-header">
//           <span className="er-logo">
//             <svg
//               className="er-logo-crest"
//               width="30"
//               height="30"
//               viewBox="0 0 40 40"
//               fill="none"
//             >
//               <circle
//                 cx="20"
//                 cy="20"
//                 r="17"
//                 stroke="#bfa15f"
//                 strokeWidth="1.4"
//               />
//               <path
//                 d="M20 6 L27 11 L27 21 C27 28 20 33 20 33 C20 33 13 28 13 21 L13 11 L20 6Z"
//                 stroke="#bfa15f"
//                 strokeWidth="1.1"
//               />
//             </svg>
//             <span className="er-logo-word">LA CHAÎNE</span>
//           </span>

//           <button type="button" className="er-back-btn" onClick={handleBack}>
//             ← Back
//           </button>
//         </div>

//         <div className="er-payment-empty">
//           <div className="er-payment-empty-icon">!</div>
//           <h2>Registration details not found</h2>
//           <p>
//             We could not load your registration details. Please go back and try
//             again.
//           </p>
//           <button type="button" className="er-pay-btn" onClick={handleBack}>
//             ← Back to Registration
//           </button>
//         </div>
//       </div>
//     );
//   }

//   const formattedUSD = hasValidPaymentAmount
//     ? `$${totalUSD.toFixed(2)}`
//     : "Amount unavailable";

//   return (
//     <>
//       <div className="er-payment-view">
//         <div className="er-page-header">
//           <span className="er-logo">
//             <svg
//               className="er-logo-crest"
//               width="30"
//               height="30"
//               viewBox="0 0 40 40"
//               fill="none"
//             >
//               <circle
//                 cx="20"
//                 cy="20"
//                 r="17"
//                 stroke="#bfa15f"
//                 strokeWidth="1.4"
//               />
//               <path
//                 d="M20 6 L27 11 L27 21 C27 28 20 33 20 33 C20 33 13 28 13 21 L13 11 L20 6Z"
//                 stroke="#bfa15f"
//                 strokeWidth="1.1"
//               />
//             </svg>
//             <span className="er-logo-word">LA CHAÎNE</span>
//           </span>

//           <button type="button" className="er-back-btn" onClick={handleBack}>
//             ← Back
//           </button>
//         </div>

//         <div className="er-payment-container">
//           <div className="er-ticket-card">
//             <div className="er-ticket-stub er-ticket-stub-left">
//               <div className="er-payment-left-content">
//                 <span className="er-payment-eyebrow">Registration Details</span>
//                 <h2 className="er-payment-left-title">
//                   Welcome, {firstName || "Guest"}
//                 </h2>
//                 <p className="er-payment-left-sub">
//                   Please review your registration details before completing your
//                   payment.
//                 </p>

//                 <div className="er-payment-order-box">
//                   <div>
//                     <span>Order ID</span>
//                     <strong>{orderId || "—"}</strong>
//                   </div>
//                   <div>
//                     <span>Registration ID</span>
//                     <strong>{registrationId || "—"}</strong>
//                   </div>
//                 </div>

//                 <div className="er-payment-summary-list">
//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Event</span>
//                     <span className="er-summary-value">{eventTitle}</span>
//                   </div>
//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Name</span>
//                     <span className="er-summary-value">
//                       {title} {firstName} {lastName}
//                     </span>
//                   </div>
//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Email</span>
//                     <span className="er-summary-value">{email || "—"}</span>
//                   </div>
//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Phone</span>
//                     <span className="er-summary-value">{phone || "—"}</span>
//                   </div>
//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Nationality</span>
//                     <span className="er-summary-value">
//                       {nationality || "—"}
//                     </span>
//                   </div>
//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Type</span>
//                     <span className="er-summary-value">{priceLabel}</span>
//                   </div>
//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Dietary</span>
//                     <span className="er-summary-value">
//                       {dietaryPreference || "No"}
//                     </span>
//                   </div>
//                   {dietaryInformation && (
//                     <div className="er-payment-summary-row">
//                       <span className="er-summary-label">Dietary info</span>
//                       <span className="er-summary-value">
//                         {dietaryInformation}
//                       </span>
//                     </div>
//                   )}
//                   {additionalInformation && (
//                     <div className="er-payment-summary-row">
//                       <span className="er-summary-label">Additional info</span>
//                       <span className="er-summary-value">
//                         {additionalInformation}
//                       </span>
//                     </div>
//                   )}
//                   {remarks && (
//                     <div className="er-payment-summary-row">
//                       <span className="er-summary-label">Remarks</span>
//                       <span className="er-summary-value">{remarks}</span>
//                     </div>
//                   )}
//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Date</span>
//                     <span className="er-summary-value">
//                       {eventDate || "—"}
//                       {checkinTime ? ` · ${checkinTime}` : ""}
//                     </span>
//                   </div>
//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Venue</span>
//                     <span className="er-summary-value">
//                       {venue || "—"}
//                       {venueCity ? `, ${venueCity}` : ""}
//                     </span>
//                   </div>
//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Payment status</span>
//                     <span className="er-summary-value">{paymentStatus}</span>
//                   </div>
//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Order status</span>
//                     <span className="er-summary-value">{orderStatus}</span>
//                   </div>
//                 </div>

//                 <div className="er-payment-summary-total">
//                   <span className="er-summary-label">Total due</span>
//                   <span className="er-summary-value">{formattedUSD}</span>
//                 </div>
//               </div>
//             </div>

//             <div className="er-ticket-divider" aria-hidden="true">
//               <span className="er-ticket-notch er-ticket-notch--start" />
//               <span className="er-ticket-dashes" />
//               <span className="er-ticket-seal">
//                 <svg viewBox="0 0 24 24" width="16" height="16" fill="none">
//                   <rect
//                     x="5"
//                     y="11"
//                     width="14"
//                     height="9"
//                     rx="2"
//                     stroke="currentColor"
//                     strokeWidth="1.8"
//                   />
//                   <path
//                     d="M8 11V7a4 4 0 0 1 8 0v4"
//                     stroke="currentColor"
//                     strokeWidth="1.8"
//                     strokeLinecap="round"
//                   />
//                 </svg>
//               </span>
//               <span className="er-ticket-dashes" />
//               <span className="er-ticket-notch er-ticket-notch--end" />
//             </div>

//             <div className="er-ticket-stub er-ticket-stub-right">
//               <div className="er-payment-card-new">
//                 <div className="er-payment-method-header">
//                   <h3 className="er-payment-method-title">Secure Payment</h3>
//                   <p className="er-payment-method-sub">
//                     Your payment is secure and encrypted.
//                   </p>
//                 </div>

//                 {isAlreadyPaid ? (
//                   <div className="er-payment-confirmed-banner">
//                     <div>Payment already completed.</div>
//                     <p>
//                       Order ID: <strong>{orderId}</strong>
//                     </p>
//                     <p>
//                       Amount: <strong>{formattedUSD}</strong>
//                     </p>
//                     <button
//                       type="button"
//                       className="er-continue-btn"
//                       onClick={() => {
//                         setPaymentResult("success");
//                         setShowSuccessPopup(true);
//                       }}
//                     >
//                       Continue to Registration →
//                     </button>
//                   </div>
//                 ) : isPaymentAmountMissing ? (
//                   <div className="er-payment-method-panel">
//                     <div className="er-error">
//                       Registration amount is unavailable. Please go back and
//                       check the registration details.
//                     </div>
//                   </div>
//                 ) : isFreeRegistration ? (
//                   <div className="er-payment-method-panel">
//                     <div className="er-free-payment-box">
//                       <div className="er-free-payment-icon">
//                         <svg
//                           viewBox="0 0 24 24"
//                           width="26"
//                           height="26"
//                           fill="none"
//                         >
//                           <circle
//                             cx="12"
//                             cy="12"
//                             r="9"
//                             stroke="currentColor"
//                             strokeWidth="1.8"
//                           />
//                           <path
//                             d="M8 12.5l2.5 2.5L16 9.5"
//                             stroke="currentColor"
//                             strokeWidth="1.8"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           />
//                         </svg>
//                       </div>
//                       <h3>No Payment Required</h3>
//                       <p>
//                         This registration is free. No payment is required for
//                         this event.
//                       </p>
//                       <div className="er-vnpay-amount-box">
//                         <span>Registration Amount</span>
//                         <strong>
//                           {currency === "USD"
//                             ? "$0.00 USD"
//                             : `0.00 ${currency}`}
//                         </strong>
//                       </div>
//                       <button
//                         type="button"
//                         className="er-pay-btn"
//                         onClick={() => {
//                           setPaymentResult("success");
//                           setShowSuccessPopup(true);
//                         }}
//                       >
//                         Continue to Registration →
//                       </button>
//                     </div>
//                   </div>
//                 ) : (
//                   <>
//                     <div className="er-payment-methods" role="radiogroup">
//                       {methods.map((method) => (
//                         <button
//                           key={method.id}
//                           type="button"
//                           role="radio"
//                           aria-checked={paymentMethod === method.id}
//                           className={`er-method-card ${
//                             paymentMethod === method.id ? "is-active" : ""
//                           }`}
//                           onClick={() => {
//                             setPaymentMethod(method.id);
//                             setVnpayError("");
//                             setCanRecheckStatus(false);
//                           }}
//                         >
//                           <span className="er-method-text">
//                             <span className="er-method-name">
//                               {method.name}
//                             </span>
//                             <span className="er-method-sub">{method.sub}</span>
//                           </span>
//                         </button>
//                       ))}
//                     </div>

//                     {paymentMethod === "vnpay" && (
//                       <div className="er-payment-method-panel">
//                         <p className="er-panel-intro">
//                           Your registration amount will be converted to VND and
//                           securely sent to VNPay.
//                         </p>

//                         <div className="er-ledger">
//                           <div className="er-vnpay-amount-box">
//                             <span>Registration Amount</span>
//                             <strong>${totalUSD.toFixed(2)} USD</strong>
//                           </div>
//                           <div className="er-vnpay-amount-box">
//                             <span>Amount for VNPay</span>
//                             <strong>{totalVND.toLocaleString()} VND</strong>
//                           </div>
//                           <div className="er-vnpay-amount-box">
//                             <span>Order ID</span>
//                             <strong>{orderId}</strong>
//                           </div>
//                         </div>

//                         {vnpayError && (
//                           <div className="er-error">
//                             {vnpayError}
//                             {canRecheckStatus && (
//                               <button
//                                 type="button"
//                                 className="er-recheck-inline-btn"
//                                 onClick={handleManualStatusCheck}
//                               >
//                                 Check Again
//                               </button>
//                             )}
//                           </div>
//                         )}

//                         <button
//                           type="button"
//                           className="er-pay-btn"
//                           onClick={handleVNPayPayment}
//                           disabled={vnpayLoading || !orderId || totalVND <= 0}
//                         >
//                           {vnpayLoading
//                             ? "Waiting for payment…"
//                             : `Pay ${totalVND.toLocaleString()} VND`}
//                         </button>

//                         <p className="er-payment-note">
//                           A secure VNPay payment window will open. Complete the
//                           payment there — this page will update once the window
//                           closes.
//                           <br />
//                           <strong>Order:</strong> {orderId}
//                         </p>
//                       </div>
//                     )}

//                     {paymentMethod === "paypal" && (
//                       <div className="er-payment-method-panel">
//                         {paymentConfirmed ? (
//                           <div className="er-payment-confirmed-banner">
//                             <div>Payment received via PayPal.</div>
//                             <p>
//                               Order ID: <strong>{orderId}</strong>
//                             </p>
//                             <button
//                               type="button"
//                               className="er-continue-btn"
//                               onClick={() => {
//                                 setPaymentResult("success");
//                                 setShowSuccessPopup(true);
//                               }}
//                             >
//                               Continue to Registration →
//                             </button>
//                           </div>
//                         ) : (
//                           <>
//                             <p className="er-panel-intro">
//                               Pay using your PayPal account or supported debit
//                               and credit cards.
//                             </p>
//                             {error && <div className="er-error">{error}</div>}
//                             <div className="er-ledger">
//                               <div className="er-vnpay-amount-box">
//                                 <span>Order ID</span>
//                                 <strong>{orderId}</strong>
//                               </div>
//                             </div>
//                             <button
//                               type="button"
//                               className="er-pay-btn"
//                               onClick={handlePayPalClick}
//                               disabled={isPaying || !orderId}
//                             >
//                               {isPaying
//                                 ? "Redirecting…"
//                                 : `Pay $${totalUSD.toFixed(2)} with PayPal`}
//                             </button>
//                           </>
//                         )}
//                       </div>
//                     )}

//                     {paymentMethod === "bank" && (
//                       <div className="er-payment-method-panel">
//                         {paymentConfirmed ? (
//                           <div className="er-payment-confirmed-banner">
//                             <div>We've recorded your bank transfer.</div>
//                             <p>
//                               Order ID: <strong>{orderId}</strong>
//                             </p>
//                             <button
//                               type="button"
//                               className="er-continue-btn"
//                               onClick={() => {
//                                 setPaymentResult("success");
//                                 setShowSuccessPopup(true);
//                               }}
//                             >
//                               Continue to Registration →
//                             </button>
//                           </div>
//                         ) : (
//                           <>
//                             <div className="er-bank-currency-row">
//                               <div className="er-bank-currency-card">
//                                 <div className="er-bank-currency-label">
//                                   Amount (USD)
//                                 </div>
//                                 <div className="er-bank-currency-amount">
//                                   ${totalUSD.toFixed(2)}
//                                 </div>
//                               </div>
//                               <div className="er-bank-currency-card">
//                                 <div className="er-bank-currency-label">
//                                   Amount (EUR)
//                                 </div>
//                                 <div className="er-bank-currency-amount">
//                                   €{totalEUR}
//                                 </div>
//                               </div>
//                             </div>

//                             <div className="er-bank-details-table">
//                               <div className="er-bank-details-row">
//                                 <span>Account Name</span>
//                                 <span>{BANK_DETAILS.accountName}</span>
//                               </div>
//                               <div className="er-bank-details-row">
//                                 <span>Bank Name</span>
//                                 <span>{BANK_DETAILS.bankName}</span>
//                               </div>
//                               <div className="er-bank-details-row">
//                                 <span>USD Account</span>
//                                 <span>{BANK_DETAILS.accountNumberUSD}</span>
//                               </div>
//                               <div className="er-bank-details-row">
//                                 <span>EUR Account</span>
//                                 <span>{BANK_DETAILS.accountNumberEUR}</span>
//                               </div>
//                               <div className="er-bank-details-row">
//                                 <span>SWIFT / BIC</span>
//                                 <span>{BANK_DETAILS.swiftCode}</span>
//                               </div>
//                               <div className="er-bank-details-row">
//                                 <span>IBAN</span>
//                                 <span>{BANK_DETAILS.iban}</span>
//                               </div>
//                               <div className="er-bank-details-row">
//                                 <span>Order ID</span>
//                                 <span>{orderId}</span>
//                               </div>
//                             </div>

//                             {error && <div className="er-error">{error}</div>}

//                             <button
//                               type="button"
//                               className="er-pay-btn"
//                               onClick={handleBankClick}
//                               disabled={isPaying || !orderId}
//                             >
//                               {isPaying
//                                 ? "Recording…"
//                                 : "I've Made the Transfer"}
//                             </button>
//                           </>
//                         )}
//                       </div>
//                     )}
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>

//           <div className="er-trust-footer">
//             <div className="er-trust-item">
//               <svg
//                 className="er-trust-icon"
//                 viewBox="0 0 24 24"
//                 width="18"
//                 height="18"
//                 fill="none"
//               >
//                 <rect
//                   x="5"
//                   y="11"
//                   width="14"
//                   height="9"
//                   rx="2"
//                   stroke="currentColor"
//                   strokeWidth="1.8"
//                 />
//                 <path
//                   d="M8 11V7a4 4 0 0 1 8 0v4"
//                   stroke="currentColor"
//                   strokeWidth="1.8"
//                   strokeLinecap="round"
//                 />
//               </svg>
//               <div className="er-trust-text">
//                 <span className="er-trust-title">Secure Payment</span>
//                 <span className="er-trust-sub">
//                   Your payment is fully encrypted
//                 </span>
//               </div>
//             </div>

//             <div className="er-trust-item">
//               <svg
//                 className="er-trust-icon"
//                 viewBox="0 0 24 24"
//                 width="18"
//                 height="18"
//                 fill="none"
//               >
//                 <circle
//                   cx="12"
//                   cy="12"
//                   r="9"
//                   stroke="currentColor"
//                   strokeWidth="1.8"
//                 />
//                 <path
//                   d="M8 12.5l2.5 2.5L16 9.5"
//                   stroke="currentColor"
//                   strokeWidth="1.8"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//               </svg>
//               <div className="er-trust-text">
//                 <span className="er-trust-title">Instant Confirmation</span>
//                 <span className="er-trust-sub">
//                   Confirmed as soon as payment clears
//                 </span>
//               </div>
//             </div>

//             <div className="er-trust-item">
//               <svg
//                 className="er-trust-icon"
//                 viewBox="0 0 24 24"
//                 width="18"
//                 height="18"
//                 fill="none"
//               >
//                 <circle
//                   cx="12"
//                   cy="12"
//                   r="9"
//                   stroke="currentColor"
//                   strokeWidth="1.8"
//                 />
//                 <path
//                   d="M9.5 9.2a2.5 2.5 0 1 1 3.5 2.3c-.8.4-1 .9-1 1.6"
//                   stroke="currentColor"
//                   strokeWidth="1.8"
//                   strokeLinecap="round"
//                 />
//                 <circle cx="12" cy="17" r="0.9" fill="currentColor" />
//               </svg>
//               <div className="er-trust-text">
//                 <span className="er-trust-title">Need Help?</span>
//                 <span className="er-trust-sub">
//                   Contact our support team anytime
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* "Verifying payment" overlay -- shown only while waiting for
//           the single check-status result after the popup closes, or
//           while a manual check is in flight. */}
//       {vnpayLoading && !showSuccessPopup && (
//         <div className="er-verifying-overlay">
//           <div className="er-verifying-box">
//             <div className="er-verifying-spinner" />
//             <h3>Verifying your payment…</h3>
//             <p>
//               This checks automatically once you close the VNPay window. You can
//               also check right now.
//             </p>
//             <div className="er-verifying-actions">
//               <button
//                 type="button"
//                 className="er-verifying-recheck-btn"
//                 onClick={handleManualStatusCheck}
//               >
//                 Check Status Now
//               </button>
//               <button
//                 type="button"
//                 className="er-verifying-cancel-btn"
//                 onClick={handleClosePaymentPopup}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showSuccessPopup && (
//         <div
//           className="registration-success-overlay"
//           onClick={handleClosePaymentPopup}
//         >
//           <div
//             className={`registration-success-modal ${
//               paymentResult === "rejected"
//                 ? "payment-rejected-modal"
//                 : "payment-success-modal"
//             }`}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               type="button"
//               className="payment-popup-close"
//               onClick={handleClosePaymentPopup}
//               aria-label="Close"
//             >
//               ×
//             </button>

//             <div
//               className={`success-icon ${
//                 paymentResult === "rejected" ? "rejected-icon" : ""
//               }`}
//             >
//               {paymentResult === "rejected" ? "!" : "✓"}
//             </div>

//             <h2>
//               {paymentResult === "rejected"
//                 ? "Payment Rejected"
//                 : isFreeRegistration
//                   ? "Registration Confirmed!"
//                   : "Payment Successful!"}
//             </h2>

//             <p>
//               {paymentResult === "rejected" ? (
//                 <>
//                   Unfortunately, your payment for <strong>{eventTitle}</strong>{" "}
//                   was rejected. You can close this and try again.
//                 </>
//               ) : (
//                 <>
//                   Your registration for <strong>{eventTitle}</strong> is now
//                   confirmed.
//                 </>
//               )}
//             </p>

//             {paymentResult === "rejected" && vnpayError && (
//               <div className="payment-rejected-message">{vnpayError}</div>
//             )}

//             <div className="success-user-info">
//               <div>
//                 <span>Order ID</span>
//                 <strong>{orderId || "—"}</strong>
//               </div>
//               <div>
//                 <span>Registration ID</span>
//                 <strong>{registrationId || "—"}</strong>
//               </div>
//               <div>
//                 <span>Event</span>
//                 <strong>{eventTitle}</strong>
//               </div>
//               <div>
//                 <span>Name</span>
//                 <strong>
//                   {title} {firstName} {lastName}
//                 </strong>
//               </div>
//               <div>
//                 <span>Email</span>
//                 <strong>{email || "—"}</strong>
//               </div>
//               <div>
//                 <span>Amount</span>
//                 <strong>{isFreeRegistration ? "FREE" : formattedUSD}</strong>
//               </div>
//               <div>
//                 <span>Payment Status</span>
//                 <strong>
//                   {paymentResult === "rejected"
//                     ? "REJECTED"
//                     : isFreeRegistration
//                       ? "FREE"
//                       : "PAID"}
//                 </strong>
//               </div>
//             </div>

//             {paymentResult !== "rejected" && email && (
//               <div className="success-message">
//                 A confirmation email will be sent to <strong>{email}</strong>.
//               </div>
//             )}

//             {paymentResult === "rejected" ? (
//               <div className="payment-popup-actions">
//                 <button
//                   type="button"
//                   className="proceed-payment-btn"
//                   onClick={handleClosePaymentPopup}
//                 >
//                   Close
//                 </button>
//               </div>
//             ) : (
//               <div className="payment-popup-actions">
//                 <button
//                   type="button"
//                   className="proceed-payment-btn"
//                   onClick={handleContinueAfterPayment}
//                 >
//                   Done
//                 </button>
//                 {!isFreeRegistration && (
//                   <button
//                     type="button"
//                     className="invoice-download-btn"
//                     onClick={handleDownloadInvoice}
//                   >
//                     Download Invoice
//                   </button>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default PaymentView;

// import React, { useEffect, useMemo, useRef, useState } from "react";
// import axios from "axios";

// import { BANK_DETAILS, USD_TO_EUR_RATE } from "./constants/eventData";
// import "./PaymentView.css";
// import { toastSuccess, toastError } from "../Services/toaster";
// // Dummy asset paths — replace with your real files in src/assets/
// import wineGlassImg from "./assets/wine-glass.jpg";        // the left panel photo
// import vnpayLogoSrc from "./assets/vnpay-logo.png";        // optional, if you want an <img>
// import paypalLogoSrc from "./assets/paypal-logo.png";      // optional, if you want an <img>
// import bankLogoSrc from "./assets/bank-logo.png";          // optional, if you want an <img>
// const USD_TO_VND_RATE = 26000;

// // Stop polling check-status after this many attempts.
// const MAX_STATUS_CHECK_ATTEMPTS = 100;
// const STATUS_CHECK_INTERVAL_MS = 3000;

// // How often we check whether the user manually closed the VNPay popup,
// // and whether the popup has navigated to a same-origin URL (see the
// // note above startStatusChecking below).
// const POPUP_WATCH_INTERVAL_MS = 800;

// /*
//  * ============================================================
//  * WHY check-status GETS CALLED MORE THAN ONCE — AND WHAT ACTUALLY
//  * GOT FIXED VS. WHAT STILL DEPENDS ON THE BACKEND
//  * ============================================================
//  *
//  * Repeated calls are inherent to the popup approach: your React app
//  * has no way to know a payment finished except by asking the backend
//  * — VNPay's own hosted page, and your backend's /api/vnpay/return,
//  * are both outside this app's control. Polling is the mechanism, not
//  * a bug, as long as it's a single clean interval.
//  *
//  * What WAS a real bug (now fixed): when the popup-close watcher fired
//  * an immediate re-check, it didn't cancel the 3-second timer already
//  * scheduled by the previous poll. That produced an extra, redundant
//  * call shortly after the manual one. Both paths now clear any pending
//  * timer before checking, so there is only ever one in-flight/one
//  * scheduled call at a time.
//  *
//  * What STILL depends on the backend: the popup currently navigates to
//  * a bare backend URL (/api/vnpay/return?...) and stays there — that
//  * page is outside this app, so nothing in React can replace what it
//  * shows. The only two real fixes are (a) your backend redirects that
//  * route to a URL on YOUR frontend's domain after processing, or (b)
//  * VNPay's own vnp_ReturnUrl is reconfigured to point at a frontend
//  * route directly. This file adds an opportunistic same-origin check
//  * (see popupWatchIntervalRef below) so that IF/WHEN either of those
//  * exists, the popup closes and the result shows instantly — but it
//  * cannot do anything while the popup stays on the API's own domain.
//  * ============================================================
//  */

// const PaymentView = ({
//   registration = {},
//   event = {},

//   paymentMethod,
//   setPaymentMethod,

//   isPaying = false,
//   paymentConfirmed = false,
//   error = "",

//   handlePayPalPayment,
//   handleBankTransferConfirm,

//   getTotalUSD,

//   onBack,
//   onPaymentSuccess,
// }) => {
//   const API_URL = process.env.REACT_APP_API_URL;

//   const [vnpayLoading, setVnpayLoading] = useState(false);
//   const [vnpayError, setVnpayError] = useState("");
//   const [vnpaySuccess, setVnpaySuccess] = useState(false);
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [paymentResult, setPaymentResult] = useState(null); // "success" | "rejected" | null

//   const popupRef = useRef(null);
//   const statusTimeoutRef = useRef(null);
//   const checkingStatusRef = useRef(false);
//   const statusCheckAttemptsRef = useRef(0);
//   const statusCheckTxnRef = useRef(null);
//   const popupWatchIntervalRef = useRef(null);

//   /*
//    * ============================================================
//    * NORMALIZE REGISTRATION DATA
//    * ============================================================
//    */
//   const registrationData = useMemo(() => {
//     if (!registration) {
//       return {};
//     }

//     if (Array.isArray(registration)) {
//       return registration[0] || {};
//     }

//     if (Array.isArray(registration.registrations)) {
//       return registration.registrations[0] || {};
//     }

//     if (registration.registration) {
//       return registration.registration;
//     }

//     return registration;
//   }, [registration]);

//   useEffect(() => {
//     console.log("========== PAYMENT VIEW ==========");
//     console.log("Original registration:", registration);
//     console.log("Normalized registration:", registrationData);
//     console.log("Event:", event);
//     console.log("==================================");
//   }, [registration, registrationData, event]);

//   const registrationId =
//     registrationData?.id !== undefined &&
//     registrationData?.id !== null &&
//     registrationData?.id !== ""
//       ? registrationData.id
//       : null;

//   const orderId =
//     registrationData?.order_id !== undefined &&
//     registrationData?.order_id !== null &&
//     registrationData?.order_id !== ""
//       ? String(registrationData.order_id)
//       : "";

//   const eventId =
//     registrationData?.event_id || event?.id || event?.event_id || null;

//   const title = registrationData?.title || "";
//   const firstName =
//     registrationData?.first_name || registrationData?.firstName || "";
//   const lastName =
//     registrationData?.last_name || registrationData?.lastName || "";
//   const email = registrationData?.email || "";
//   const phone = registrationData?.phone || "";
//   const nationality = registrationData?.nationality || "";
//   const dietaryPreference = registrationData?.dietary_preference || "";
//   const dietaryInformation = registrationData?.dietary_information || "";
//   const additionalInformation = registrationData?.additional_information || "";
//   const remarks = registrationData?.remarks || "";
//   const isMember =
//     registrationData?.is_member === true || registrationData?.is_member === 1;
//   const memberId = registrationData?.member_id || 0;
//   const guestId = registrationData?.guest_id || 0;
//   const vatInvoiceRequired =
//     registrationData?.vat_invoice_required === true ||
//     registrationData?.vat_invoice_required === 1;

//   const currency = registrationData?.currency || "USD";
//   const currencyUpper = String(currency).trim().toUpperCase();

//   const paymentStatus = String(
//     registrationData?.payment_status || "PENDING",
//   ).toUpperCase();

//   const orderStatus = String(
//     registrationData?.order_status || "ACTIVE",
//   ).toUpperCase();

//   const eventTitle =
//     event?.event_title || event?.title || event?.name || "Event Registration";
//   const eventDate = event?.event_date || event?.date || "";
//   const checkinTime = event?.checkin_time || event?.checkinTime || "";
//   const venue = event?.venue || "";
//   const venueCity = event?.venue_city || event?.venueCity || "";

//   const rawPrice = registrationData?.price;

//   const hasRegistrationPrice =
//     rawPrice !== undefined &&
//     rawPrice !== null &&
//     rawPrice !== "" &&
//     Number.isFinite(Number(rawPrice));

//   const rawAmount = hasRegistrationPrice ? Number(rawPrice) : null;

//   const totalUSD = useMemo(() => {
//     if (rawAmount !== null) {
//       if (currencyUpper === "VND") {
//         return rawAmount / USD_TO_VND_RATE;
//       }
//       return rawAmount;
//     }

//     if (typeof getTotalUSD === "function") {
//       const parentAmount = Number(getTotalUSD());
//       if (Number.isFinite(parentAmount)) {
//         return parentAmount;
//       }
//     }

//     return null;
//   }, [rawAmount, currencyUpper, getTotalUSD]);

//   const hasValidPaymentAmount =
//     totalUSD !== null && Number.isFinite(totalUSD) && totalUSD >= 0;
//   const isFreeRegistration = hasValidPaymentAmount && totalUSD === 0;
//   const isPaymentAmountMissing = totalUSD === null;

//   const totalEUR = useMemo(() => {
//     if (!hasValidPaymentAmount) {
//       return "0.00";
//     }
//     return (totalUSD * USD_TO_EUR_RATE).toFixed(2);
//   }, [totalUSD, hasValidPaymentAmount]);

//   const totalVND = useMemo(() => {
//     if (!hasValidPaymentAmount) {
//       return 0;
//     }
//     if (currencyUpper === "VND" && rawAmount !== null) {
//       return Math.round(rawAmount);
//     }
//     return Math.round(totalUSD * USD_TO_VND_RATE);
//   }, [totalUSD, hasValidPaymentAmount, currencyUpper, rawAmount]);

//   const priceLabel = isMember ? "Member" : "Guest";

//   const isAlreadyPaid =
//     paymentStatus === "PAID" ||
//     paymentStatus === "SUCCESS" ||
//     paymentStatus === "SUCCESSFUL" ||
//     paymentStatus === "COMPLETED";

//   const methods = [
//     { id: "vnpay", name: "VNPAY", sub: "ATM · QR · Banking" },
//     { id: "paypal", name: "PayPal", sub: "Card / PayPal balance" },
//     { id: "bank", name: "Bank Transfer", sub: "USD / EUR wire" },
//   ];

//   const stopStatusChecking = () => {
//     if (statusTimeoutRef.current) {
//       clearTimeout(statusTimeoutRef.current);
//       statusTimeoutRef.current = null;
//     }
//     if (popupWatchIntervalRef.current) {
//       clearInterval(popupWatchIntervalRef.current);
//       popupWatchIntervalRef.current = null;
//     }
//     checkingStatusRef.current = false;
//     statusCheckAttemptsRef.current = 0;
//     statusCheckTxnRef.current = null;
//   };

//   const closeVNPayPopup = () => {
//     if (popupRef.current && !popupRef.current.closed) {
//       popupRef.current.close();
//     }
//     popupRef.current = null;
//   };

//   useEffect(() => {
//     return () => {
//       stopStatusChecking();
//       closeVNPayPopup();
//     };
//   }, []);

//   const handleBack = () => {
//     stopStatusChecking();
//     closeVNPayPopup();
//     if (onBack) {
//       onBack();
//       return;
//     }
//     window.history.back();
//   };

//   const handleDownloadInvoice = async () => {
//     if (!orderId) {
//       toastError("Order ID is missing.");
//       return;
//     }

//     try {
//       const response = await axios.get(`${API_URL}/api/invoices/${orderId}`, {
//         responseType: "blob",
//       });

//       const blob = new Blob([response.data], { type: "application/pdf" });
//       const url = window.URL.createObjectURL(blob);

//       const link = document.createElement("a");
//       link.href = url;
//       link.download = `Invoice-${orderId}.pdf`;

//       document.body.appendChild(link);
//       link.click();
//       link.remove();

//       window.URL.revokeObjectURL(url);

//       toastSuccess("Invoice downloaded successfully.");
//     } catch (err) {
//       console.error("Invoice download error:", err?.response?.data || err);
//       toastError("Unable to download invoice.");
//     }
//   };

//   const handleContinueAfterPayment = () => {
//     setShowSuccessPopup(false);
//     stopStatusChecking();
//     closeVNPayPopup();

//     if (onPaymentSuccess) {
//       onPaymentSuccess({
//         registration: registrationData,
//         registrationId,
//         eventId,
//         orderId,
//         amount: totalUSD,
//         currency,
//         paymentStatus: isFreeRegistration ? "FREE" : "PAID",
//       });
//       return;
//     }

//     console.warn("onPaymentSuccess is not provided.");
//   };
//   const handleClosePaymentPopup = () => {
//     setShowSuccessPopup(false);
//     stopStatusChecking();
//     closeVNPayPopup();
//     setVnpayLoading(false);
//   };

//   const getPaymentStatus = (data) => {
//     return String(
//       data?.status ||
//         data?.payment_status ||
//         data?.transaction_status ||
//         data?.paymentStatus ||
//         data?.data?.status ||
//         data?.data?.payment_status ||
//         data?.data?.transaction_status ||
//         "",
//     ).toLowerCase();
//   };

//   const isPaymentSuccessful = (data) => {
//     const status = getPaymentStatus(data);
//     return (
//       data?.success === true ||
//       data?.paid === true ||
//       data?.payment_success === true ||
//       data?.data?.success === true ||
//       data?.data?.paid === true ||
//       data?.data?.payment_success === true ||
//       ["success", "successful", "paid", "completed", "complete"].includes(
//         status,
//       )
//     );
//   };

//   const isPaymentFailed = (data) => {
//     const status = getPaymentStatus(data);
//     return [
//       "failed",
//       "failure",
//       "rejected",
//       "cancelled",
//       "canceled",
//       "error",
//     ].includes(status);
//   };

//   /*
//    * Single active timer, guaranteed: every path that leads here first
//    * clears statusTimeoutRef, so there is never a stray scheduled call
//    * left over from a previous cycle.
//    */
//   const checkVNPayStatus = async (txnRef) => {
//     if (!txnRef) {
//       console.error("VNPay status check skipped: txn_ref is missing.");
//       return;
//     }

//     if (statusCheckTxnRef.current !== txnRef) {
//       return;
//     }

//     if (checkingStatusRef.current) {
//       return;
//     }

//     if (statusCheckAttemptsRef.current >= MAX_STATUS_CHECK_ATTEMPTS) {
//       stopStatusChecking();
//       setVnpayLoading(false);

//       const message =
//         "We couldn't confirm your payment status. Please try again or choose another payment method.";
//       setVnpayError(message);
//       toastError(message);
//       return;
//     }

//     checkingStatusRef.current = true;
//     statusCheckAttemptsRef.current += 1;

//     try {
//       const response = await axios.get(`${API_URL}/api/vnpay/check-status`, {
//         params: { txn_ref: txnRef },
//       });

//       const data = response.data;

//       console.log(
//         `VNPay status check #${statusCheckAttemptsRef.current}:`,
//         data,
//       );

//       if (isPaymentSuccessful(data)) {
//         stopStatusChecking();
//         closeVNPayPopup();

//         setVnpayLoading(false);
//         setVnpaySuccess(true);
//         setVnpayError("");

//         setPaymentResult("success");
//         setShowSuccessPopup(true);

//         toastSuccess("Payment completed successfully!");
//         return;
//       }

//       if (isPaymentFailed(data)) {
//         const message =
//           data?.message || data?.detail || "Payment was rejected or failed.";
//         const cleanMessage =
//           typeof message === "string"
//             ? message
//             : "Payment was rejected or failed.";

//         stopStatusChecking();
//         closeVNPayPopup();

//         setVnpayLoading(false);
//         setVnpaySuccess(false);
//         setVnpayError(cleanMessage);

//         setPaymentResult("rejected");
//         setShowSuccessPopup(true);

//         toastError(cleanMessage);
//         return;
//       }

//       if (
//         statusCheckTxnRef.current === txnRef &&
//         statusCheckAttemptsRef.current < MAX_STATUS_CHECK_ATTEMPTS
//       ) {
//         statusTimeoutRef.current = setTimeout(() => {
//           statusTimeoutRef.current = null;
//           checkVNPayStatus(txnRef);
//         }, STATUS_CHECK_INTERVAL_MS);
//       }
//     } catch (err) {
//       console.error("VNPay Status Check Error:", err?.response?.data || err);

//       if (
//         statusCheckTxnRef.current === txnRef &&
//         statusCheckAttemptsRef.current < MAX_STATUS_CHECK_ATTEMPTS
//       ) {
//         statusTimeoutRef.current = setTimeout(() => {
//           statusTimeoutRef.current = null;
//           checkVNPayStatus(txnRef);
//         }, STATUS_CHECK_INTERVAL_MS);
//       }
//     } finally {
//       checkingStatusRef.current = false;
//     }
//   };

//   const startStatusChecking = (txnRef) => {
//     if (!txnRef) {
//       console.error("VNPay status checking cannot start: txn_ref is missing.");
//       return;
//     }

//     stopStatusChecking();

//     statusCheckAttemptsRef.current = 0;
//     statusCheckTxnRef.current = txnRef;

//     checkVNPayStatus(txnRef);

//     popupWatchIntervalRef.current = setInterval(() => {
//       const popup = popupRef.current;
//       if (!popup) return;

//       if (popup.closed) {
//         clearInterval(popupWatchIntervalRef.current);
//         popupWatchIntervalRef.current = null;

//         if (statusTimeoutRef.current) {
//           clearTimeout(statusTimeoutRef.current);
//           statusTimeoutRef.current = null;
//         }

//         if (statusCheckTxnRef.current === txnRef) {
//           checkVNPayStatus(txnRef);
//         }
//         return;
//       }

//       try {
//         const popupUrl = popup.location.href;
//         if (popupUrl && popupUrl.indexOf(window.location.origin) === 0) {
//           clearInterval(popupWatchIntervalRef.current);
//           popupWatchIntervalRef.current = null;

//           if (statusTimeoutRef.current) {
//             clearTimeout(statusTimeoutRef.current);
//             statusTimeoutRef.current = null;
//           }

//           if (statusCheckTxnRef.current === txnRef) {
//             checkVNPayStatus(txnRef);
//           }
//         }
//       } catch (e) {
//         // Cross-origin access throws while popup is on VNPay/API domain — expected.
//       }
//     }, POPUP_WATCH_INTERVAL_MS);
//   };

//   const handleManualStatusCheck = () => {
//     const txnRef = statusCheckTxnRef.current;
//     if (!txnRef) return;

//     if (statusTimeoutRef.current) {
//       clearTimeout(statusTimeoutRef.current);
//       statusTimeoutRef.current = null;
//     }

//     checkVNPayStatus(txnRef);
//   };

//   const handleVNPayPayment = async () => {
//     if (!registrationData || Object.keys(registrationData).length === 0) {
//       const message =
//         "Registration information is missing. Please go back and register again.";
//       setVnpayError(message);
//       toastError(message);
//       return;
//     }

//     if (!orderId) {
//       const message =
//         "Order ID is missing from the registration. Please register again.";
//       setVnpayError(message);
//       toastError(message);
//       console.error(
//         "VNPay payment stopped: order_id missing.",
//         registrationData,
//       );
//       return;
//     }

//     if (isPaymentAmountMissing) {
//       const message =
//         "Registration amount is missing. Please check the registration details.";
//       setVnpayError(message);
//       toastError(message);
//       return;
//     }

//     if (isFreeRegistration) {
//       const message = "This registration is free. No payment is required.";
//       setVnpayError(message);
//       toastError(message);
//       return;
//     }

//     if (!totalVND || totalVND <= 0) {
//       const message = "VNPay payment amount is invalid.";
//       setVnpayError(message);
//       toastError(message);
//       return;
//     }

//     const width = 500;
//     const height = 750;
//     const left = window.screenX + (window.outerWidth - width) / 2;
//     const top = window.screenY + (window.outerHeight - height) / 2;

//     const paymentPopup = window.open(
//       "",
//       "vnpay_payment",
//       `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
//     );

//     if (!paymentPopup) {
//       const message =
//         "Payment popup was blocked. Please allow popups and try again.";
//       setVnpayError(message);
//       toastError(message);
//       return;
//     }

//     popupRef.current = paymentPopup;

//     try {
//       setVnpayLoading(true);
//       setVnpayError("");
//       setVnpaySuccess(false);

//       const paymentPayload = {
//         amount: totalVND,
//         order_id: orderId,
//       };

//       console.log("========== CREATE VNPAY PAYMENT ==========");
//       console.log({
//         registrationId,
//         eventId,
//         orderId,
//         currencyFromBackend: currency,
//         amountUSD: totalUSD,
//         amountVND: totalVND,
//         paymentPayload,
//       });
//       console.log("===========================================");

//       const response = await axios.post(
//         `${API_URL}/api/vnpay/create-payment`,
//         paymentPayload,
//         {
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//           },
//         },
//       );

//       const data = response.data;

//       console.log("VNPay create-payment response:", data);

//       if (!data?.success || !data?.payment_url) {
//         closeVNPayPopup();

//         const message =
//           data?.message ||
//           data?.detail ||
//           "Unable to create VNPay payment. Please try again.";
//         const cleanMessage =
//           typeof message === "string"
//             ? message
//             : "Unable to create VNPay payment. Please try again.";

//         setVnpayError(cleanMessage);
//         toastError(cleanMessage);
//         setVnpayLoading(false);
//         return;
//       }

//       const txnRef = data?.txn_ref || data?.data?.txn_ref || null;

//       if (!txnRef) {
//         closeVNPayPopup();

//         const message =
//           "VNPay transaction reference is missing. Please try again.";
//         setVnpayError(message);
//         toastError(message);
//         setVnpayLoading(false);

//         console.error(
//           "VNPay create-payment response does not contain txn_ref:",
//           data,
//         );
//         return;
//       }

//       console.log("VNPay txn_ref:", txnRef);

//       paymentPopup.location.href = data.payment_url;

//       startStatusChecking(txnRef);
//     } catch (err) {
//       console.error("VNPay Payment Error:", err?.response?.data || err);

//       closeVNPayPopup();
//       stopStatusChecking();

//       const errorMessage =
//         err?.response?.data?.detail?.[0]?.msg ||
//         err?.response?.data?.detail?.message ||
//         err?.response?.data?.detail ||
//         err?.response?.data?.message ||
//         "Failed to create VNPay payment. Please try again.";

//       const message =
//         typeof errorMessage === "string"
//           ? errorMessage
//           : "Failed to create VNPay payment. Please try again.";

//       setVnpayError(message);
//       toastError(message);
//       setVnpayLoading(false);
//     }
//   };

//   const handlePayPalClick = () => {
//     if (!orderId) {
//       toastError("Order ID is missing. Please register again.");
//       return;
//     }
//     if (isPaymentAmountMissing) {
//       toastError("Registration amount is missing.");
//       return;
//     }
//     if (isFreeRegistration) {
//       setPaymentResult("success");
//       setShowSuccessPopup(true);
//       return;
//     }
//     if (typeof handlePayPalPayment !== "function") {
//       toastError("PayPal payment is not configured.");
//       return;
//     }

//     handlePayPalPayment({
//       orderId,
//       registrationId,
//       eventId,
//       amount: totalUSD,
//       currency,
//       registration: registrationData,
//     });
//   };

//   const handleBankClick = () => {
//     if (!orderId) {
//       toastError("Order ID is missing. Please register again.");
//       return;
//     }
//     if (isPaymentAmountMissing) {
//       toastError("Registration amount is missing.");
//       return;
//     }
//     if (typeof handleBankTransferConfirm !== "function") {
//       toastError("Bank transfer payment is not configured.");
//       return;
//     }

//     handleBankTransferConfirm({
//       orderId,
//       registrationId,
//       eventId,
//       amount: totalUSD,
//       currency,
//       registration: registrationData,
//     });
//   };

//   const hasRegistrationData =
//     registrationData &&
//     typeof registrationData === "object" &&
//     !Array.isArray(registrationData) &&
//     Object.keys(registrationData).length > 0;

//   if (!hasRegistrationData) {
//     return (
//       <div className="er-payment-view">
//         <div className="er-page-header">
//           <span className="er-logo">
//             <svg
//               className="er-logo-crest"
//               width="30"
//               height="30"
//               viewBox="0 0 40 40"
//               fill="none"
//             >
//               <circle
//                 cx="20"
//                 cy="20"
//                 r="17"
//                 stroke="#bfa15f"
//                 strokeWidth="1.4"
//               />
//               <path
//                 d="M20 6 L27 11 L27 21 C27 28 20 33 20 33 C20 33 13 28 13 21 L13 11 L20 6Z"
//                 stroke="#bfa15f"
//                 strokeWidth="1.1"
//               />
//             </svg>
//             <span className="er-logo-word">LA CHAÎNE</span>
//           </span>

//           <button type="button" className="er-back-btn" onClick={handleBack}>
//             ← Back
//           </button>
//         </div>

//         <div className="er-payment-empty">
//           <div className="er-payment-empty-icon">!</div>
//           <h2>Registration details not found</h2>
//           <p>
//             We could not load your registration details. Please go back and try
//             again.
//           </p>
//           <button type="button" className="er-pay-btn" onClick={handleBack}>
//             ← Back to Registration
//           </button>
//         </div>
//       </div>
//     );
//   }

//   const formattedUSD = hasValidPaymentAmount
//     ? `$${totalUSD.toFixed(2)}`
//     : "Amount unavailable";

//   return (
//     <>
//       <div className="er-payment-view">
//         <div className="er-page-header">
//           <span className="er-logo">
//             <svg
//               className="er-logo-crest"
//               width="30"
//               height="30"
//               viewBox="0 0 40 40"
//               fill="none"
//             >
//               <circle
//                 cx="20"
//                 cy="20"
//                 r="17"
//                 stroke="#bfa15f"
//                 strokeWidth="1.4"
//               />
//               <path
//                 d="M20 6 L27 11 L27 21 C27 28 20 33 20 33 C20 33 13 28 13 21 L13 11 L20 6Z"
//                 stroke="#bfa15f"
//                 strokeWidth="1.1"
//               />
//             </svg>
//             <span className="er-logo-word">LA CHAÎNE</span>
//           </span>

//           <button type="button" className="er-back-btn" onClick={handleBack}>
//             ← Back
//           </button>
//         </div>

//         <div className="er-payment-container">
//           <div className="er-ticket-card">
//             <div className="er-ticket-stub er-ticket-stub-left">
//               <div className="er-payment-left-content">
//                 <span className="er-payment-eyebrow">Registration Details</span>

//                 <h2 className="er-payment-left-title">
//                   Welcome, {firstName || "Guest"}
//                 </h2>

//                 <p className="er-payment-left-sub">
//                   Please review your registration details before completing your
//                   payment.
//                 </p>

//                 <div className="er-payment-order-box">
//                   <div>
//                     <span>Order ID</span>
//                     <strong>{orderId || "—"}</strong>
//                   </div>
//                   <div>
//                     <span>Registration ID</span>
//                     <strong>{registrationId || "—"}</strong>
//                   </div>
//                 </div>

//                 <div className="er-payment-summary-list">
//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Event</span>
//                     <span className="er-summary-value">{eventTitle}</span>
//                   </div>

//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Name</span>
//                     <span className="er-summary-value">
//                       {title} {firstName} {lastName}
//                     </span>
//                   </div>

//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Email</span>
//                     <span className="er-summary-value">{email || "—"}</span>
//                   </div>

//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Phone</span>
//                     <span className="er-summary-value">{phone || "—"}</span>
//                   </div>

//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Nationality</span>
//                     <span className="er-summary-value">
//                       {nationality || "—"}
//                     </span>
//                   </div>

//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Type</span>
//                     <span className="er-summary-value">{priceLabel}</span>
//                   </div>

//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Dietary</span>
//                     <span className="er-summary-value">
//                       {dietaryPreference || "No"}
//                     </span>
//                   </div>

//                   {dietaryInformation && (
//                     <div className="er-payment-summary-row">
//                       <span className="er-summary-label">Dietary info</span>
//                       <span className="er-summary-value">
//                         {dietaryInformation}
//                       </span>
//                     </div>
//                   )}

//                   {additionalInformation && (
//                     <div className="er-payment-summary-row">
//                       <span className="er-summary-label">Additional info</span>
//                       <span className="er-summary-value">
//                         {additionalInformation}
//                       </span>
//                     </div>
//                   )}

//                   {remarks && (
//                     <div className="er-payment-summary-row">
//                       <span className="er-summary-label">Remarks</span>
//                       <span className="er-summary-value">{remarks}</span>
//                     </div>
//                   )}

//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Date</span>
//                     <span className="er-summary-value">
//                       {eventDate || "—"}
//                       {checkinTime ? ` · ${checkinTime}` : ""}
//                     </span>
//                   </div>

//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Venue</span>
//                     <span className="er-summary-value">
//                       {venue || "—"}
//                       {venueCity ? `, ${venueCity}` : ""}
//                     </span>
//                   </div>

//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Payment status</span>
//                     <span className="er-summary-value">{paymentStatus}</span>
//                   </div>

//                   <div className="er-payment-summary-row">
//                     <span className="er-summary-label">Order status</span>
//                     <span className="er-summary-value">{orderStatus}</span>
//                   </div>
//                 </div>

//                 <div className="er-payment-summary-total">
//                   <span className="er-summary-label">Total due</span>
//                   <span className="er-summary-value">{formattedUSD}</span>
//                 </div>
//               </div>
//             </div>

//             <div className="er-ticket-divider" aria-hidden="true">
//               <span className="er-ticket-notch er-ticket-notch--start" />
//               <span className="er-ticket-dashes" />
//               <span className="er-ticket-seal">
//                 <svg viewBox="0 0 24 24" width="16" height="16" fill="none">
//                   <rect
//                     x="5"
//                     y="11"
//                     width="14"
//                     height="9"
//                     rx="2"
//                     stroke="currentColor"
//                     strokeWidth="1.8"
//                   />
//                   <path
//                     d="M8 11V7a4 4 0 0 1 8 0v4"
//                     stroke="currentColor"
//                     strokeWidth="1.8"
//                     strokeLinecap="round"
//                   />
//                 </svg>
//               </span>
//               <span className="er-ticket-dashes" />
//               <span className="er-ticket-notch er-ticket-notch--end" />
//             </div>

//             <div className="er-ticket-stub er-ticket-stub-right">
//               <div className="er-payment-card-new">
//                 <div className="er-payment-method-header">
//                   <h3 className="er-payment-method-title">Secure Payment</h3>
//                   <p className="er-payment-method-sub">
//                     Your payment is secure and encrypted.
//                   </p>
//                 </div>

//                 {isAlreadyPaid ? (
//                   <div className="er-payment-confirmed-banner">
//                     <div>Payment already completed.</div>
//                     <p>
//                       Order ID: <strong>{orderId}</strong>
//                     </p>
//                     <p>
//                       Amount: <strong>{formattedUSD}</strong>
//                     </p>
//                     <button
//                       type="button"
//                       className="er-continue-btn"
//                       onClick={() => {
//                         setPaymentResult("success");
//                         setShowSuccessPopup(true);
//                       }}
//                     >
//                       Continue to Registration →
//                     </button>
//                   </div>
//                 ) : isPaymentAmountMissing ? (
//                   <div className="er-payment-method-panel">
//                     <div className="er-error">
//                       Registration amount is unavailable. Please go back and
//                       check the registration details.
//                     </div>
//                   </div>
//                 ) : isFreeRegistration ? (
//                   <div className="er-payment-method-panel">
//                     <div className="er-free-payment-box">
//                       <div className="er-free-payment-icon">
//                         <svg
//                           viewBox="0 0 24 24"
//                           width="26"
//                           height="26"
//                           fill="none"
//                         >
//                           <circle
//                             cx="12"
//                             cy="12"
//                             r="9"
//                             stroke="currentColor"
//                             strokeWidth="1.8"
//                           />
//                           <path
//                             d="M8 12.5l2.5 2.5L16 9.5"
//                             stroke="currentColor"
//                             strokeWidth="1.8"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           />
//                         </svg>
//                       </div>

//                       <h3>No Payment Required</h3>

//                       <p>
//                         This registration is free. No payment is required for
//                         this event.
//                       </p>

//                       <div className="er-vnpay-amount-box">
//                         <span>Registration Amount</span>
//                         <strong>
//                           {currency === "USD"
//                             ? "$0.00 USD"
//                             : `0.00 ${currency}`}
//                         </strong>
//                       </div>

//                       <button
//                         type="button"
//                         className="er-pay-btn"
//                         onClick={() => {
//                           setPaymentResult("success");
//                           setShowSuccessPopup(true);
//                         }}
//                       >
//                         Continue to Registration →
//                       </button>
//                     </div>
//                   </div>
//                 ) : (
//                   <>
//                     <div className="er-payment-methods" role="radiogroup">
//                       {methods.map((method) => (
//                         <button
//                           key={method.id}
//                           type="button"
//                           role="radio"
//                           aria-checked={paymentMethod === method.id}
//                           className={`er-method-card ${paymentMethod === method.id ? "is-active" : ""}`}
//                           onClick={() => {
//                             setPaymentMethod(method.id);
//                             setVnpayError("");
//                           }}
//                         >
//                           <span className="er-method-icon">
//                             {method.id === "vnpay" && (
//                               <svg
//                                 viewBox="0 0 24 24"
//                                 width="20"
//                                 height="20"
//                                 fill="none"
//                               >
//                                 <rect
//                                   x="3.5"
//                                   y="3.5"
//                                   width="6"
//                                   height="6"
//                                   rx="1"
//                                   stroke="currentColor"
//                                   strokeWidth="1.7"
//                                 />
//                                 <rect
//                                   x="14.5"
//                                   y="3.5"
//                                   width="6"
//                                   height="6"
//                                   rx="1"
//                                   stroke="currentColor"
//                                   strokeWidth="1.7"
//                                 />
//                                 <rect
//                                   x="3.5"
//                                   y="14.5"
//                                   width="6"
//                                   height="6"
//                                   rx="1"
//                                   stroke="currentColor"
//                                   strokeWidth="1.7"
//                                 />
//                                 <path
//                                   d="M14.5 15h2.5v2.5M20.5 15v5h-6v-2.5"
//                                   stroke="currentColor"
//                                   strokeWidth="1.7"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 />
//                               </svg>
//                             )}
//                             {method.id === "paypal" && (
//                               <svg
//                                 viewBox="0 0 24 24"
//                                 width="20"
//                                 height="20"
//                                 fill="none"
//                               >
//                                 <rect
//                                   x="3"
//                                   y="6"
//                                   width="18"
//                                   height="13"
//                                   rx="2"
//                                   stroke="currentColor"
//                                   strokeWidth="1.7"
//                                 />
//                                 <path
//                                   d="M3 10.5h18"
//                                   stroke="currentColor"
//                                   strokeWidth="1.7"
//                                 />
//                                 <path
//                                   d="M6.5 14.5h4"
//                                   stroke="currentColor"
//                                   strokeWidth="1.7"
//                                   strokeLinecap="round"
//                                 />
//                               </svg>
//                             )}
//                             {method.id === "bank" && (
//                               <svg
//                                 viewBox="0 0 24 24"
//                                 width="20"
//                                 height="20"
//                                 fill="none"
//                               >
//                                 <path
//                                   d="M4 10h16M4 10l3-4h10l3 4M4 10v8h16v-8"
//                                   stroke="currentColor"
//                                   strokeWidth="1.7"
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                 />
//                                 <path
//                                   d="M8 14v2M12 14v2M16 14v2"
//                                   stroke="currentColor"
//                                   strokeWidth="1.7"
//                                   strokeLinecap="round"
//                                 />
//                               </svg>
//                             )}
//                           </span>

//                           <span className="er-method-text">
//                             <span className="er-method-name">
//                               {method.name}
//                             </span>
//                             <span className="er-method-sub">{method.sub}</span>
//                           </span>
//                         </button>
//                       ))}
//                     </div>

//                     {paymentMethod === "vnpay" && (
//                       <div className="er-payment-method-panel">
//                         <p className="er-panel-intro">
//                           Your registration amount will be converted to VND and
//                           securely sent to VNPay.
//                         </p>

//                         <div className="er-ledger">
//                           <div className="er-vnpay-amount-box">
//                             <span>Registration Amount</span>
//                             <strong>${totalUSD.toFixed(2)} USD</strong>
//                           </div>
//                           <div className="er-vnpay-amount-box">
//                             <span>Amount for VNPay</span>
//                             <strong>{totalVND.toLocaleString()} VND</strong>
//                           </div>
//                           <div className="er-vnpay-amount-box">
//                             <span>Order ID</span>
//                             <strong>{orderId}</strong>
//                           </div>
//                         </div>

//                         {vnpayError && (
//                           <div className="er-error">{vnpayError}</div>
//                         )}

//                         <button
//                           type="button"
//                           className="er-pay-btn"
//                           onClick={handleVNPayPayment}
//                           disabled={vnpayLoading || !orderId || totalVND <= 0}
//                         >
//                           {vnpayLoading
//                             ? "Waiting for payment…"
//                             : `Pay ${totalVND.toLocaleString()} VND`}
//                         </button>

//                         <p className="er-payment-note">
//                           A secure VNPay payment window will open. Complete the
//                           payment there.
//                           <br />
//                           <strong>Order:</strong> {orderId}
//                         </p>
//                       </div>
//                     )}

//                     {paymentMethod === "paypal" && (
//                       <div className="er-payment-method-panel">
//                         {paymentConfirmed ? (
//                           <div className="er-payment-confirmed-banner">
//                             <div>Payment received via PayPal.</div>
//                             <p>
//                               Order ID: <strong>{orderId}</strong>
//                             </p>
//                             <button
//                               type="button"
//                               className="er-continue-btn"
//                               onClick={() => {
//                                 setPaymentResult("success");
//                                 setShowSuccessPopup(true);
//                               }}
//                             >
//                               Continue to Registration →
//                             </button>
//                           </div>
//                         ) : (
//                           <>
//                             <p className="er-panel-intro">
//                               Pay using your PayPal account or supported debit
//                               and credit cards.
//                             </p>

//                             {error && <div className="er-error">{error}</div>}

//                             <div className="er-ledger">
//                               <div className="er-vnpay-amount-box">
//                                 <span>Order ID</span>
//                                 <strong>{orderId}</strong>
//                               </div>
//                             </div>

//                             <button
//                               type="button"
//                               className="er-pay-btn"
//                               onClick={handlePayPalClick}
//                               disabled={isPaying || !orderId}
//                             >
//                               {isPaying
//                                 ? "Redirecting…"
//                                 : `Pay $${totalUSD.toFixed(2)} with PayPal`}
//                             </button>
//                           </>
//                         )}
//                       </div>
//                     )}

//                     {paymentMethod === "bank" && (
//                       <div className="er-payment-method-panel">
//                         {paymentConfirmed ? (
//                           <div className="er-payment-confirmed-banner">
//                             <div>We've recorded your bank transfer.</div>
//                             <p>
//                               Order ID: <strong>{orderId}</strong>
//                             </p>
//                             <button
//                               type="button"
//                               className="er-continue-btn"
//                               onClick={() => {
//                                 setPaymentResult("success");
//                                 setShowSuccessPopup(true);
//                               }}
//                             >
//                               Continue to Registration →
//                             </button>
//                           </div>
//                         ) : (
//                           <>
//                             <div className="er-bank-currency-row">
//                               <div className="er-bank-currency-card">
//                                 <div className="er-bank-currency-label">
//                                   Amount (USD)
//                                 </div>
//                                 <div className="er-bank-currency-amount">
//                                   ${totalUSD.toFixed(2)}
//                                 </div>
//                               </div>
//                               <div className="er-bank-currency-card">
//                                 <div className="er-bank-currency-label">
//                                   Amount (EUR)
//                                 </div>
//                                 <div className="er-bank-currency-amount">
//                                   €{totalEUR}
//                                 </div>
//                               </div>
//                             </div>

//                             <div className="er-bank-details-table">
//                               <div className="er-bank-details-row">
//                                 <span>Account Name</span>
//                                 <span>{BANK_DETAILS.accountName}</span>
//                               </div>
//                               <div className="er-bank-details-row">
//                                 <span>Bank Name</span>
//                                 <span>{BANK_DETAILS.bankName}</span>
//                               </div>
//                               <div className="er-bank-details-row">
//                                 <span>USD Account</span>
//                                 <span>{BANK_DETAILS.accountNumberUSD}</span>
//                               </div>
//                               <div className="er-bank-details-row">
//                                 <span>EUR Account</span>
//                                 <span>{BANK_DETAILS.accountNumberEUR}</span>
//                               </div>
//                               <div className="er-bank-details-row">
//                                 <span>SWIFT / BIC</span>
//                                 <span>{BANK_DETAILS.swiftCode}</span>
//                               </div>
//                               <div className="er-bank-details-row">
//                                 <span>IBAN</span>
//                                 <span>{BANK_DETAILS.iban}</span>
//                               </div>
//                               <div className="er-bank-details-row">
//                                 <span>Order ID</span>
//                                 <span>{orderId}</span>
//                               </div>
//                             </div>

//                             {error && <div className="er-error">{error}</div>}

//                             <button
//                               type="button"
//                               className="er-pay-btn"
//                               onClick={handleBankClick}
//                               disabled={isPaying || !orderId}
//                             >
//                               {isPaying
//                                 ? "Recording…"
//                                 : "I've Made the Transfer"}
//                             </button>
//                           </>
//                         )}
//                       </div>
//                     )}
//                   </>
//                 )}
//               </div>
//             </div>
//           </div>

//           <div className="er-trust-footer">
//             <div className="er-trust-item">
//               <svg
//                 className="er-trust-icon"
//                 viewBox="0 0 24 24"
//                 width="18"
//                 height="18"
//                 fill="none"
//               >
//                 <rect
//                   x="5"
//                   y="11"
//                   width="14"
//                   height="9"
//                   rx="2"
//                   stroke="currentColor"
//                   strokeWidth="1.8"
//                 />
//                 <path
//                   d="M8 11V7a4 4 0 0 1 8 0v4"
//                   stroke="currentColor"
//                   strokeWidth="1.8"
//                   strokeLinecap="round"
//                 />
//               </svg>
//               <div className="er-trust-text">
//                 <span className="er-trust-title">Secure Payment</span>
//                 <span className="er-trust-sub">
//                   Your payment is fully encrypted
//                 </span>
//               </div>
//             </div>

//             <div className="er-trust-item">
//               <svg
//                 className="er-trust-icon"
//                 viewBox="0 0 24 24"
//                 width="18"
//                 height="18"
//                 fill="none"
//               >
//                 <circle
//                   cx="12"
//                   cy="12"
//                   r="9"
//                   stroke="currentColor"
//                   strokeWidth="1.8"
//                 />
//                 <path
//                   d="M8 12.5l2.5 2.5L16 9.5"
//                   stroke="currentColor"
//                   strokeWidth="1.8"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//               </svg>
//               <div className="er-trust-text">
//                 <span className="er-trust-title">Instant Confirmation</span>
//                 <span className="er-trust-sub">
//                   Confirmed as soon as payment clears
//                 </span>
//               </div>
//             </div>

//             <div className="er-trust-item">
//               <svg
//                 className="er-trust-icon"
//                 viewBox="0 0 24 24"
//                 width="18"
//                 height="18"
//                 fill="none"
//               >
//                 <circle
//                   cx="12"
//                   cy="12"
//                   r="9"
//                   stroke="currentColor"
//                   strokeWidth="1.8"
//                 />
//                 <path
//                   d="M9.5 9.2a2.5 2.5 0 1 1 3.5 2.3c-.8.4-1 .9-1 1.6"
//                   stroke="currentColor"
//                   strokeWidth="1.8"
//                   strokeLinecap="round"
//                 />
//                 <circle cx="12" cy="17" r="0.9" fill="currentColor" />
//               </svg>
//               <div className="er-trust-text">
//                 <span className="er-trust-title">Need Help?</span>
//                 <span className="er-trust-sub">
//                   Contact our support team anytime
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {vnpayLoading && !showSuccessPopup && (
//         <div className="er-verifying-overlay">
//           <div className="er-verifying-box">
//             <div className="er-verifying-spinner" />
//             <h3>Verifying your payment…</h3>
//             <p>
//               Complete your payment in the VNPay window. This will update
//               automatically once it's done.
//             </p>

//             <div className="er-verifying-actions">
//               <button
//                 type="button"
//                 className="er-verifying-recheck-btn"
//                 onClick={handleManualStatusCheck}
//               >
//                 Check Status Now
//               </button>
//               <button
//                 type="button"
//                 className="er-verifying-cancel-btn"
//                 onClick={handleClosePaymentPopup}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showSuccessPopup && (
//         <div
//           className="registration-success-overlay"
//           onClick={handleClosePaymentPopup}
//         >
//           <div
//             className={`registration-success-modal ${
//               paymentResult === "rejected"
//                 ? "payment-rejected-modal"
//                 : "payment-success-modal"
//             }`}
//             onClick={(e) => e.stopPropagation()}
//           >
//             {paymentResult === "rejected" && (
//               <button
//                 type="button"
//                 className="payment-popup-close"
//                 onClick={handleClosePaymentPopup}
//                 aria-label="Close"
//               >
//                 ×
//               </button>
//             )}

//             <div
//               className={`success-icon ${paymentResult === "rejected" ? "rejected-icon" : ""}`}
//             >
//               {paymentResult === "rejected" ? "!" : "✓"}
//             </div>

//             <h2>
//               {paymentResult === "rejected"
//                 ? "Payment Rejected"
//                 : isFreeRegistration
//                   ? "Registration Confirmed!"
//                   : "Payment Successful!"}
//             </h2>

//             <p>
//               {paymentResult === "rejected" ? (
//                 <>
//                   Unfortunately, your payment for <strong>{eventTitle}</strong>{" "}
//                   was rejected. Close this and pay again to complete your
//                   registration.
//                 </>
//               ) : (
//                 <>
//                   Your registration for <strong>{eventTitle}</strong> is now
//                   confirmed.
//                 </>
//               )}
//             </p>

//             {paymentResult === "rejected" && vnpayError && (
//               <div className="payment-rejected-message">{vnpayError}</div>
//             )}

//             <div className="success-user-info">
//               <div>
//                 <span>Order ID</span>
//                 <strong>{orderId || "—"}</strong>
//               </div>
//               <div>
//                 <span>Registration ID</span>
//                 <strong>{registrationId || "—"}</strong>
//               </div>
//               <div>
//                 <span>Event</span>
//                 <strong>{eventTitle}</strong>
//               </div>
//               <div>
//                 <span>Name</span>
//                 <strong>
//                   {title} {firstName} {lastName}
//                 </strong>
//               </div>
//               <div>
//                 <span>Email</span>
//                 <strong>{email || "—"}</strong>
//               </div>
//               <div>
//                 <span>Amount</span>
//                 <strong>{isFreeRegistration ? "FREE" : formattedUSD}</strong>
//               </div>
//               <div>
//                 <span>Payment Status</span>
//                 <strong>
//                   {paymentResult === "rejected"
//                     ? "REJECTED"
//                     : isFreeRegistration
//                       ? "FREE"
//                       : "PAID"}
//                 </strong>
//               </div>
//             </div>

//             {paymentResult !== "rejected" && email && (
//               <div className="success-message">
//                 A confirmation email will be sent to <strong>{email}</strong>.
//               </div>
//             )}

//             {paymentResult === "rejected" ? (
//               <div className="payment-popup-actions">
//                 <button
//                   type="button"
//                   className="proceed-payment-btn"
//                   onClick={handleClosePaymentPopup}
//                 >
//                   Close &amp; Pay Again
//                 </button>
//               </div>
//             ) : (
//               <div className="payment-popup-actions">
//                 <button
//                   type="button"
//                   className="proceed-payment-btn"
//                   onClick={handleContinueAfterPayment}
//                 >
//                   Done
//                 </button>

//                 {!isFreeRegistration && (
//                   <button
//                     type="button"
//                     className="invoice-download-btn"
//                     onClick={handleDownloadInvoice}
//                   >
//                     Download Invoice
//                   </button>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default PaymentView;
import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";

import { BANK_DETAILS, USD_TO_EUR_RATE } from "./constants/eventData";
import "./PaymentView.css";
import { toastSuccess, toastError } from "../Services/toaster";

// Dummy asset — replace with your real file.
// If you don't have the image yet, comment this out and
// swap the <img> below for <div className="er-hero-image" style={{ background: "#2a070c" }} />.
import wineGlassImg from "../assets/icons/wineglass1.png";

const USD_TO_VND_RATE = 26000;

// Stop polling check-status after this many attempts.
const MAX_STATUS_CHECK_ATTEMPTS = 100;
const STATUS_CHECK_INTERVAL_MS = 3000;

// How often we check whether the user manually closed the VNPay popup,
// and whether the popup has navigated to a same-origin URL.
const POPUP_WATCH_INTERVAL_MS = 800;

const PaymentView = ({
  registration = {},
  event = {},

  paymentMethod,
  setPaymentMethod,

  isPaying = false,
  paymentConfirmed = false,
  error = "",

  handlePayPalPayment,
  handleBankTransferConfirm,

  getTotalUSD,

  onBack,
  onPaymentSuccess,
}) => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [vnpayLoading, setVnpayLoading] = useState(false);
  const [vnpayError, setVnpayError] = useState("");
  const [vnpaySuccess, setVnpaySuccess] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [paymentResult, setPaymentResult] = useState(null); // "success" | "rejected" | null

  const popupRef = useRef(null);
  const statusTimeoutRef = useRef(null);
  const checkingStatusRef = useRef(false);
  const statusCheckAttemptsRef = useRef(0);
  const statusCheckTxnRef = useRef(null);
  const popupWatchIntervalRef = useRef(null);

  /* ============================================================
     NORMALIZE REGISTRATION DATA
  ============================================================ */
  const registrationData = useMemo(() => {
    if (!registration) return {};
    if (Array.isArray(registration)) return registration[0] || {};
    if (Array.isArray(registration.registrations)) {
      return registration.registrations[0] || {};
    }
    if (registration.registration) return registration.registration;
    return registration;
  }, [registration]);

  useEffect(() => {
    console.log("========== PAYMENT VIEW ==========");
    console.log("Original registration:", registration);
    console.log("Normalized registration:", registrationData);
    console.log("Event:", event);
    console.log("==================================");
  }, [registration, registrationData, event]);

  const registrationId =
    registrationData?.id !== undefined &&
    registrationData?.id !== null &&
    registrationData?.id !== ""
      ? registrationData.id
      : null;

  const orderId =
    registrationData?.order_id !== undefined &&
    registrationData?.order_id !== null &&
    registrationData?.order_id !== ""
      ? String(registrationData.order_id)
      : "";

  const eventId =
    registrationData?.event_id || event?.id || event?.event_id || null;

  const title = registrationData?.title || "";
  const firstName =
    registrationData?.first_name || registrationData?.firstName || "";
  const lastName =
    registrationData?.last_name || registrationData?.lastName || "";
  const email = registrationData?.email || "";
  const phone = registrationData?.phone || "";
  const nationality = registrationData?.nationality || "";
  const dietaryPreference = registrationData?.dietary_preference || "";
  const dietaryInformation = registrationData?.dietary_information || "";
  const additionalInformation = registrationData?.additional_information || "";
  const remarks = registrationData?.remarks || "";
  const isMember =
    registrationData?.is_member === true || registrationData?.is_member === 1;

  const currency = registrationData?.currency || "USD";
  const currencyUpper = String(currency).trim().toUpperCase();

  const paymentStatus = String(
    registrationData?.payment_status || "PENDING",
  ).toUpperCase();

  const orderStatus = String(
    registrationData?.order_status || "ACTIVE",
  ).toUpperCase();

  const eventTitle =
    event?.event_title || event?.title || event?.name || "Event Registration";
  const eventDate = event?.event_date || event?.date || "";
  const checkinTime = event?.checkin_time || event?.checkinTime || "";
  const venue = event?.venue || "";
  const venueCity = event?.venue_city || event?.venueCity || "";

  const rawPrice = registrationData?.price;

  const hasRegistrationPrice =
    rawPrice !== undefined &&
    rawPrice !== null &&
    rawPrice !== "" &&
    Number.isFinite(Number(rawPrice));

  const rawAmount = hasRegistrationPrice ? Number(rawPrice) : null;

  const totalUSD = useMemo(() => {
    if (rawAmount !== null) {
      if (currencyUpper === "VND") return rawAmount / USD_TO_VND_RATE;
      return rawAmount;
    }
    if (typeof getTotalUSD === "function") {
      const parentAmount = Number(getTotalUSD());
      if (Number.isFinite(parentAmount)) return parentAmount;
    }
    return null;
  }, [rawAmount, currencyUpper, getTotalUSD]);

  const hasValidPaymentAmount =
    totalUSD !== null && Number.isFinite(totalUSD) && totalUSD >= 0;
  const isFreeRegistration = hasValidPaymentAmount && totalUSD === 0;
  const isPaymentAmountMissing = totalUSD === null;

  const totalEUR = useMemo(() => {
    if (!hasValidPaymentAmount) return "0.00";
    return (totalUSD * USD_TO_EUR_RATE).toFixed(2);
  }, [totalUSD, hasValidPaymentAmount]);

  const totalVND = useMemo(() => {
    if (!hasValidPaymentAmount) return 0;
    if (currencyUpper === "VND" && rawAmount !== null) {
      return Math.round(rawAmount);
    }
    return Math.round(totalUSD * USD_TO_VND_RATE);
  }, [totalUSD, hasValidPaymentAmount, currencyUpper, rawAmount]);

  const priceLabel = isMember ? "Member" : "Guest";

  const isAlreadyPaid =
    paymentStatus === "PAID" ||
    paymentStatus === "SUCCESS" ||
    paymentStatus === "SUCCESSFUL" ||
    paymentStatus === "COMPLETED";

  const methods = [
    {
      id: "vnpay",
      name: "VNPAY",
      sub: "ATM · QR · Internet Banking",
      popular: true,
    },
    { id: "paypal", name: "PayPal", sub: "Card / PayPal balance" },
    { id: "bank", name: "Bank Transfer", sub: "USD / EUR Wire" },
  ];

  /* ============================================================
     CLEANUP
  ============================================================ */
  const stopStatusChecking = () => {
    if (statusTimeoutRef.current) {
      clearTimeout(statusTimeoutRef.current);
      statusTimeoutRef.current = null;
    }
    if (popupWatchIntervalRef.current) {
      clearInterval(popupWatchIntervalRef.current);
      popupWatchIntervalRef.current = null;
    }
    checkingStatusRef.current = false;
    statusCheckAttemptsRef.current = 0;
    statusCheckTxnRef.current = null;
  };

  const closeVNPayPopup = () => {
    if (popupRef.current && !popupRef.current.closed) {
      popupRef.current.close();
    }
    popupRef.current = null;
  };

  useEffect(() => {
    return () => {
      stopStatusChecking();
      closeVNPayPopup();
    };
  }, []);

  const handleBack = () => {
    stopStatusChecking();
    closeVNPayPopup();
    if (onBack) {
      onBack();
      return;
    }
    window.history.back();
  };

  const handleDownloadInvoice = async () => {
    if (!orderId) {
      toastError("Order ID is missing.");
      return;
    }
    try {
      const response = await axios.get(`${API_URL}/api/invoices/${orderId}`, {
        responseType: "blob",
      });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Invoice-${orderId}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toastSuccess("Invoice downloaded successfully.");
    } catch (err) {
      console.error("Invoice download error:", err?.response?.data || err);
      toastError("Unable to download invoice.");
    }
  };

  const handleContinueAfterPayment = () => {
    setShowSuccessPopup(false);
    stopStatusChecking();
    closeVNPayPopup();

    if (onPaymentSuccess) {
      onPaymentSuccess({
        registration: registrationData,
        registrationId,
        eventId,
        orderId,
        amount: totalUSD,
        currency,
        paymentStatus: isFreeRegistration ? "FREE" : "PAID",
      });
      return;
    }
    console.warn("onPaymentSuccess is not provided.");
  };

  const handleClosePaymentPopup = () => {
    setShowSuccessPopup(false);
    stopStatusChecking();
    closeVNPayPopup();
    setVnpayLoading(false);
  };

  /* ============================================================
     STATUS HELPERS
  ============================================================ */
  const getPaymentStatus = (data) =>
    String(
      data?.status ||
        data?.payment_status ||
        data?.transaction_status ||
        data?.paymentStatus ||
        data?.data?.status ||
        data?.data?.payment_status ||
        data?.data?.transaction_status ||
        "",
    ).toLowerCase();

  const isPaymentSuccessful = (data) => {
    const status = getPaymentStatus(data);
    return (
      data?.success === true ||
      data?.paid === true ||
      data?.payment_success === true ||
      data?.data?.success === true ||
      data?.data?.paid === true ||
      data?.data?.payment_success === true ||
      ["success", "successful", "paid", "completed", "complete"].includes(
        status,
      )
    );
  };

  const isPaymentFailed = (data) => {
    const status = getPaymentStatus(data);
    return [
      "failed",
      "failure",
      "rejected",
      "cancelled",
      "canceled",
      "error",
    ].includes(status);
  };

  const checkVNPayStatus = async (txnRef) => {
    if (!txnRef) return;
    if (statusCheckTxnRef.current !== txnRef) return;
    if (checkingStatusRef.current) return;

    if (statusCheckAttemptsRef.current >= MAX_STATUS_CHECK_ATTEMPTS) {
      stopStatusChecking();
      setVnpayLoading(false);
      const message =
        "We couldn't confirm your payment status. Please try again or choose another payment method.";
      setVnpayError(message);
      toastError(message);
      return;
    }

    checkingStatusRef.current = true;
    statusCheckAttemptsRef.current += 1;

    try {
      const response = await axios.get(`${API_URL}/api/vnpay/check-status`, {
        params: { txn_ref: txnRef },
      });
      const data = response.data;
      console.log(
        `VNPay status check #${statusCheckAttemptsRef.current}:`,
        data,
      );

      if (isPaymentSuccessful(data)) {
        stopStatusChecking();
        closeVNPayPopup();
        setVnpayLoading(false);
        setVnpaySuccess(true);
        setVnpayError("");
        setPaymentResult("success");
        setShowSuccessPopup(true);
        toastSuccess("Payment completed successfully!");
        return;
      }

      if (isPaymentFailed(data)) {
        const message =
          data?.message || data?.detail || "Payment was rejected or failed.";
        const cleanMessage =
          typeof message === "string"
            ? message
            : "Payment was rejected or failed.";
        stopStatusChecking();
        closeVNPayPopup();
        setVnpayLoading(false);
        setVnpaySuccess(false);
        setVnpayError(cleanMessage);
        setPaymentResult("rejected");
        setShowSuccessPopup(true);
        toastError(cleanMessage);
        return;
      }

      if (
        statusCheckTxnRef.current === txnRef &&
        statusCheckAttemptsRef.current < MAX_STATUS_CHECK_ATTEMPTS
      ) {
        statusTimeoutRef.current = setTimeout(() => {
          statusTimeoutRef.current = null;
          checkVNPayStatus(txnRef);
        }, STATUS_CHECK_INTERVAL_MS);
      }
    } catch (err) {
      console.error("VNPay Status Check Error:", err?.response?.data || err);
      if (
        statusCheckTxnRef.current === txnRef &&
        statusCheckAttemptsRef.current < MAX_STATUS_CHECK_ATTEMPTS
      ) {
        statusTimeoutRef.current = setTimeout(() => {
          statusTimeoutRef.current = null;
          checkVNPayStatus(txnRef);
        }, STATUS_CHECK_INTERVAL_MS);
      }
    } finally {
      checkingStatusRef.current = false;
    }
  };

  const startStatusChecking = (txnRef) => {
    if (!txnRef) return;
    stopStatusChecking();
    statusCheckAttemptsRef.current = 0;
    statusCheckTxnRef.current = txnRef;
    checkVNPayStatus(txnRef);

    popupWatchIntervalRef.current = setInterval(() => {
      const popup = popupRef.current;
      if (!popup) return;

      if (popup.closed) {
        clearInterval(popupWatchIntervalRef.current);
        popupWatchIntervalRef.current = null;
        if (statusTimeoutRef.current) {
          clearTimeout(statusTimeoutRef.current);
          statusTimeoutRef.current = null;
        }
        if (statusCheckTxnRef.current === txnRef) {
          checkVNPayStatus(txnRef);
        }
        return;
      }

      try {
        const popupUrl = popup.location.href;
        if (popupUrl && popupUrl.indexOf(window.location.origin) === 0) {
          clearInterval(popupWatchIntervalRef.current);
          popupWatchIntervalRef.current = null;
          if (statusTimeoutRef.current) {
            clearTimeout(statusTimeoutRef.current);
            statusTimeoutRef.current = null;
          }
          if (statusCheckTxnRef.current === txnRef) {
            checkVNPayStatus(txnRef);
          }
        }
      } catch (e) {
        // Cross-origin — expected while popup is on VNPay/API domain.
      }
    }, POPUP_WATCH_INTERVAL_MS);
  };

  const handleManualStatusCheck = () => {
    const txnRef = statusCheckTxnRef.current;
    if (!txnRef) return;
    if (statusTimeoutRef.current) {
      clearTimeout(statusTimeoutRef.current);
      statusTimeoutRef.current = null;
    }
    checkVNPayStatus(txnRef);
  };

  /* ============================================================
     VNPAY PAYMENT
  ============================================================ */
  const handleVNPayPayment = async () => {
    if (!registrationData || Object.keys(registrationData).length === 0) {
      const message =
        "Registration information is missing. Please go back and register again.";
      setVnpayError(message);
      toastError(message);
      return;
    }

    if (!orderId) {
      const message =
        "Order ID is missing from the registration. Please register again.";
      setVnpayError(message);
      toastError(message);
      return;
    }

    if (isPaymentAmountMissing) {
      const message =
        "Registration amount is missing. Please check the registration details.";
      setVnpayError(message);
      toastError(message);
      return;
    }

    if (isFreeRegistration) {
      const message = "This registration is free. No payment is required.";
      setVnpayError(message);
      toastError(message);
      return;
    }

    if (!totalVND || totalVND <= 0) {
      const message = "VNPay payment amount is invalid.";
      setVnpayError(message);
      toastError(message);
      return;
    }

    /* Centered popup — multi-monitor safe */
    const width = Math.min(500, window.screen.availWidth - 100);
    const height = Math.min(750, window.screen.availHeight - 100);

    const dualScreenLeft = window.screenLeft ?? window.screenX ?? 0;
    const dualScreenTop = window.screenTop ?? window.screenY ?? 0;

    const viewportW =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      window.screen.width;
    const viewportH =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      window.screen.height;

    const left = Math.round(dualScreenLeft + (viewportW - width) / 2);
    const top = Math.round(dualScreenTop + (viewportH - height) / 2);

    const popupName = `vnpay_payment_${Date.now()}`;

    const paymentPopup = window.open(
      "",
      popupName,
      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
    );

    if (!paymentPopup) {
      const message =
        "Payment popup was blocked. Please allow popups and try again.";
      setVnpayError(message);
      toastError(message);
      return;
    }

    popupRef.current = paymentPopup;

    try {
      setVnpayLoading(true);
      setVnpayError("");
      setVnpaySuccess(false);

      const paymentPayload = { amount: totalVND, order_id: orderId };

      console.log("========== CREATE VNPAY PAYMENT ==========");
      console.log({
        registrationId,
        eventId,
        orderId,
        currencyFromBackend: currency,
        amountUSD: totalUSD,
        amountVND: totalVND,
        paymentPayload,
      });
      console.log("===========================================");

      const response = await axios.post(
        `${API_URL}/api/vnpay/create-payment`,
        paymentPayload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      );

      const data = response.data;
      console.log("VNPay create-payment response:", data);

      if (!data?.success || !data?.payment_url) {
        closeVNPayPopup();
        const message =
          data?.message ||
          data?.detail ||
          "Unable to create VNPay payment. Please try again.";
        const cleanMessage =
          typeof message === "string"
            ? message
            : "Unable to create VNPay payment. Please try again.";
        setVnpayError(cleanMessage);
        toastError(cleanMessage);
        setVnpayLoading(false);
        return;
      }

      const txnRef = data?.txn_ref || data?.data?.txn_ref || null;

      if (!txnRef) {
        closeVNPayPopup();
        const message =
          "VNPay transaction reference is missing. Please try again.";
        setVnpayError(message);
        toastError(message);
        setVnpayLoading(false);
        return;
      }

      console.log("VNPay txn_ref:", txnRef);
      paymentPopup.location.href = data.payment_url;
      startStatusChecking(txnRef);
    } catch (err) {
      console.error("VNPay Payment Error:", err?.response?.data || err);
      closeVNPayPopup();
      stopStatusChecking();

      const errorMessage =
        err?.response?.data?.detail?.[0]?.msg ||
        err?.response?.data?.detail?.message ||
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        "Failed to create VNPay payment. Please try again.";

      const message =
        typeof errorMessage === "string"
          ? errorMessage
          : "Failed to create VNPay payment. Please try again.";

      setVnpayError(message);
      toastError(message);
      setVnpayLoading(false);
    }
  };

  /* ============================================================
     PAYPAL
  ============================================================ */
  const handlePayPalClick = () => {
    if (!orderId) {
      toastError("Order ID is missing. Please register again.");
      return;
    }
    if (isPaymentAmountMissing) {
      toastError("Registration amount is missing.");
      return;
    }
    if (isFreeRegistration) {
      setPaymentResult("success");
      setShowSuccessPopup(true);
      return;
    }
    if (typeof handlePayPalPayment !== "function") {
      toastError("PayPal payment is not configured.");
      return;
    }
    handlePayPalPayment({
      orderId,
      registrationId,
      eventId,
      amount: totalUSD,
      currency,
      registration: registrationData,
    });
  };

  /* ============================================================
     BANK TRANSFER
  ============================================================ */
  const handleBankClick = () => {
    if (!orderId) {
      toastError("Order ID is missing. Please register again.");
      return;
    }
    if (isPaymentAmountMissing) {
      toastError("Registration amount is missing.");
      return;
    }
    if (typeof handleBankTransferConfirm !== "function") {
      toastError("Bank transfer payment is not configured.");
      return;
    }
    handleBankTransferConfirm({
      orderId,
      registrationId,
      eventId,
      amount: totalUSD,
      currency,
      registration: registrationData,
    });
  };

  /* ============================================================
     EMPTY-STATE GUARD
  ============================================================ */
  const hasRegistrationData =
    registrationData &&
    typeof registrationData === "object" &&
    !Array.isArray(registrationData) &&
    Object.keys(registrationData).length > 0;

  if (!hasRegistrationData) {
    return (
      <div className="er-payment-view">
        <div className="er-payment-empty">
          <div className="er-payment-empty-icon">!</div>
          <h2>Registration details not found</h2>
          <p>
            We could not load your registration details. Please go back and try
            again.
          </p>
          <button type="button" className="er-pay-btn" onClick={handleBack}>
            ← Back to Registration
          </button>
        </div>
      </div>
    );
  }

  const formattedUSD = hasValidPaymentAmount
    ? `$${totalUSD.toFixed(2)}`
    : "Amount unavailable";
  return (
    <>
      <div className="er-payment-view">
        {/* ================= HERO ROW ================= */}
        <div className="er-hero-row">
          {/* Left: full-height image column */}
          <aside className="er-hero-left">
            <img src={wineGlassImg} alt="" className="er-hero-image" />
            <div className="er-hero-overlay" />
            {/* <div className="er-hero-footer-caption">
              <span>EXCLUSIVE</span>
              <span>NETWORKING</span>
              <span>EVENTS</span>
            </div> */}
          </aside>

          {/* Right: content */}
          <main className="er-hero-right">
            <div className="er-hero-heading">
              <span className="er-hero-eyebrow">
                A PREMIUM EXPERIENCE AWAITS
              </span>
              <h1 className="er-hero-title">Complete Your Payment</h1>
              {/* <p className="er-hero-sub">
                Your registration is almost complete. Please review the details
                and choose your preferred payment method.
              </p> */}
            </div>

            {/* TWO SEPARATE BOXES */}
            <div className="er-payment-split">
              {/* ===== LEFT BOX: Registration Details ===== */}
              <div className="er-ticket-stub er-ticket-stub-left">
                <div className="er-payment-left-content">
                  {/* Event Details */}
                  <section className="er-left-section">
                    <header className="er-left-section-head">
                      <span className="er-left-section-icon">
                        <svg
                          viewBox="0 0 24 24"
                          width="16"
                          height="16"
                          fill="none"
                        >
                          <rect
                            x="3.5"
                            y="5"
                            width="17"
                            height="15"
                            rx="2"
                            stroke="currentColor"
                            strokeWidth="1.6"
                          />
                          <path
                            d="M3.5 9.5h17M8 3v4M16 3v4"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                          />
                        </svg>
                      </span>
                      <span className="er-left-section-title">
                        EVENT DETAILS
                      </span>
                    </header>
                    <h3 className="er-left-event-title">{eventTitle}</h3>
                    <p className="er-left-event-meta">
                      <svg
                        viewBox="0 0 24 24"
                        width="13"
                        height="13"
                        fill="none"
                      >
                        <rect
                          x="3.5"
                          y="5"
                          width="17"
                          height="15"
                          rx="2"
                          stroke="currentColor"
                          strokeWidth="1.7"
                        />
                        <path
                          d="M3.5 9.5h17M8 3v4M16 3v4"
                          stroke="currentColor"
                          strokeWidth="1.7"
                          strokeLinecap="round"
                        />
                      </svg>
                      {eventDate || "—"}
                      {venue && (
                        <>
                          <span className="er-dot">•</span>
                          <svg
                            viewBox="0 0 24 24"
                            width="13"
                            height="13"
                            fill="none"
                          >
                            <path
                              d="M12 21s-7-6-7-11a7 7 0 1 1 14 0c0 5-7 11-7 11z"
                              stroke="currentColor"
                              strokeWidth="1.7"
                            />
                            <circle
                              cx="12"
                              cy="10"
                              r="2.5"
                              stroke="currentColor"
                              strokeWidth="1.7"
                            />
                          </svg>
                          {venue}
                          {venueCity ? `, ${venueCity}` : ""}
                        </>
                      )}
                    </p>
                  </section>

                  {/* Attendee Information */}
                  <section className="er-left-section">
                    <header className="er-left-section-head">
                      <span className="er-left-section-icon">
                        <svg
                          viewBox="0 0 24 24"
                          width="16"
                          height="16"
                          fill="none"
                        >
                          <circle
                            cx="12"
                            cy="8"
                            r="3.5"
                            stroke="currentColor"
                            strokeWidth="1.6"
                          />
                          <path
                            d="M4.5 20c1-3.5 4-5.5 7.5-5.5s6.5 2 7.5 5.5"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                          />
                        </svg>
                      </span>
                      <span className="er-left-section-title">
                        ATTENDEE INFORMATION
                      </span>
                    </header>
                    <div className="er-kv-list">
                      <div className="er-kv">
                        <span>Name</span>
                        <span>
                          {title} {firstName} {lastName}
                        </span>
                      </div>
                      <div className="er-kv">
                        <span>Email</span>
                        <span>{email || "—"}</span>
                      </div>
                      <div className="er-kv">
                        <span>Phone</span>
                        <span>{phone || "—"}</span>
                      </div>
                      <div className="er-kv">
                        <span>Nationality</span>
                        <span>{nationality || "—"}</span>
                      </div>
                    </div>
                  </section>

                  {/* Registration Details */}
                  <section className="er-left-section">
                    <header className="er-left-section-head">
                      <span className="er-left-section-icon">
                        <svg
                          viewBox="0 0 24 24"
                          width="16"
                          height="16"
                          fill="none"
                        >
                          <path
                            d="M6 3h9l3 3v15H6z"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M9 9h6M9 13h6M9 17h4"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                          />
                        </svg>
                      </span>
                      <span className="er-left-section-title">
                        REGISTRATION DETAILS
                      </span>
                    </header>
                    <div className="er-kv-list">
                      <div className="er-kv">
                        <span>Type</span>
                        <span>{priceLabel}</span>
                      </div>
                      <div className="er-kv">
                        <span>Dietary</span>
                        <span>{dietaryPreference || "No"}</span>
                      </div>
                      <div className="er-kv">
                        <span>Date</span>
                        <span>
                          {eventDate || "—"}
                          {checkinTime ? ` | ${checkinTime}` : ""}
                        </span>
                      </div>
                      <div className="er-kv">
                        <span>Venue</span>
                        <span>
                          {venue || "—"}
                          {venueCity ? `, ${venueCity}` : ""}
                        </span>
                      </div>
                      <div className="er-kv">
                        <span>Payment status</span>
                        <span>
                          <span
                            className={`er-pill er-pill--${paymentStatus.toLowerCase()}`}
                          >
                            {paymentStatus}
                          </span>
                        </span>
                      </div>
                      <div className="er-kv">
                        <span>Order status</span>
                        <span>
                          <span
                            className={`er-pill er-pill--${orderStatus.toLowerCase()}`}
                          >
                            {orderStatus}
                          </span>
                        </span>
                      </div>
                    </div>
                  </section>

                  <div className="er-payment-summary-total">
                    <span className="er-summary-label">TOTAL DUE</span>
                    <span className="er-summary-value">{formattedUSD}</span>
                  </div>
                </div>
              </div>

              {/* ===== RIGHT BOX: Payment ===== */}
              <div className="er-ticket-stub er-ticket-stub-right">
                <div className="er-payment-card-new">
                  <div className="er-payment-method-header">
                    <div className="er-payment-method-title-row">
                      <svg
                        className="er-secure-icon"
                        viewBox="0 0 24 24"
                        width="22"
                        height="22"
                        fill="none"
                      >
                        <path
                          d="M12 3 L20 6 V12 C20 17 12 21 12 21 C12 21 4 17 4 12 V6 L12 3Z"
                          stroke="#7a1f2b"
                          strokeWidth="1.6"
                          fill="none"
                        />
                        <path
                          d="M9 12 l2 2 4 -4"
                          stroke="#7a1f2b"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          fill="none"
                        />
                      </svg>
                      <h3 className="er-payment-method-title">
                        Secure Payment
                      </h3>
                      <span className="er-ssl-badge">
                        <svg
                          viewBox="0 0 24 24"
                          width="12"
                          height="12"
                          fill="none"
                        >
                          <rect
                            x="5"
                            y="11"
                            width="14"
                            height="9"
                            rx="2"
                            stroke="currentColor"
                            strokeWidth="2"
                          />
                          <path
                            d="M8 11V7a4 4 0 0 1 8 0v4"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                        SSL Encrypted
                      </span>
                    </div>
                    <p className="er-payment-method-sub">
                      Your payment is secure and encrypted.
                    </p>
                  </div>

                  {isAlreadyPaid ? (
                    <div className="er-payment-confirmed-banner">
                      <div>Payment already completed.</div>
                      <p>
                        Order ID: <strong>{orderId}</strong>
                      </p>
                      <p>
                        Amount: <strong>{formattedUSD}</strong>
                      </p>
                      <button
                        type="button"
                        className="er-continue-btn"
                        onClick={() => {
                          setPaymentResult("success");
                          setShowSuccessPopup(true);
                        }}
                      >
                        Continue to Registration →
                      </button>
                    </div>
                  ) : isPaymentAmountMissing ? (
                    <div className="er-payment-method-panel">
                      <div className="er-error">
                        Registration amount is unavailable. Please go back and
                        check the registration details.
                      </div>
                    </div>
                  ) : isFreeRegistration ? (
                    <div className="er-payment-method-panel">
                      <div className="er-free-payment-box">
                        <div className="er-free-payment-icon">
                          <svg
                            viewBox="0 0 24 24"
                            width="26"
                            height="26"
                            fill="none"
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="9"
                              stroke="currentColor"
                              strokeWidth="1.8"
                            />
                            <path
                              d="M8 12.5l2.5 2.5L16 9.5"
                              stroke="currentColor"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <h3>No Payment Required</h3>
                        <p>
                          This registration is free. No payment is required for
                          this event.
                        </p>
                        <div className="er-vnpay-amount-box">
                          <span>Registration Amount</span>
                          <strong>
                            {currency === "USD"
                              ? "$0.00 USD"
                              : `0.00 ${currency}`}
                          </strong>
                        </div>
                        <button
                          type="button"
                          className="er-pay-btn"
                          onClick={() => {
                            setPaymentResult("success");
                            setShowSuccessPopup(true);
                          }}
                        >
                          Continue to Registration →
                        </button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <p className="er-choose-title">
                        Choose Your Payment Method
                      </p>

                      <div className="er-payment-methods" role="radiogroup">
                        {methods.map((method) => (
                          <button
                            key={method.id}
                            type="button"
                            role="radio"
                            aria-checked={paymentMethod === method.id}
                            className={`er-method-card ${paymentMethod === method.id ? "is-active" : ""}`}
                            onClick={() => {
                              setPaymentMethod(method.id);
                              setVnpayError("");
                            }}
                          >
                            <span
                              className={`er-method-radio ${paymentMethod === method.id ? "is-checked" : ""}`}
                            >
                              {paymentMethod === method.id && (
                                <span className="er-method-radio-dot" />
                              )}
                            </span>

                            <span className="er-method-logo">
                              {method.id === "vnpay" && (
                                <svg viewBox="0 0 48 48" width="34" height="34">
                                  <rect
                                    x="2"
                                    y="2"
                                    width="44"
                                    height="44"
                                    rx="8"
                                    fill="#fff"
                                  />
                                  <path
                                    d="M24 6 L34 16 L24 26 L14 16 Z"
                                    fill="#0d5fb3"
                                  />
                                  <path
                                    d="M14 24 L24 34 L34 24 L34 30 L24 40 L14 30 Z"
                                    fill="#e53935"
                                  />
                                  <text
                                    x="24"
                                    y="20"
                                    textAnchor="middle"
                                    fontSize="7"
                                    fontWeight="700"
                                    fill="#fff"
                                    fontFamily="Inter, sans-serif"
                                  >
                                    VN
                                  </text>
                                </svg>
                              )}
                              {method.id === "paypal" && (
                                <svg viewBox="0 0 48 48" width="34" height="34">
                                  <path
                                    d="M18 8h10c5 0 8 2.5 8 7 0 5-4 9-10 9h-3l-2 12h-6L18 8z"
                                    fill="#003087"
                                  />
                                  <path
                                    d="M22 14h10c5 0 8 2.5 8 7 0 5-4 9-10 9h-3l-2 12h-6L22 14z"
                                    fill="#009cde"
                                    opacity="0.9"
                                  />
                                </svg>
                              )}
                              {method.id === "bank" && (
                                <svg viewBox="0 0 48 48" width="34" height="34">
                                  <circle
                                    cx="24"
                                    cy="24"
                                    r="20"
                                    fill="#f4ede2"
                                  />
                                  <path
                                    d="M12 20 L24 12 L36 20 M14 20 v12 M22 20 v12 M26 20 v12 M34 20 v12 M12 34 h24"
                                    stroke="#9c803f"
                                    strokeWidth="1.8"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </span>

                            <span className="er-method-text">
                              <span className="er-method-name">
                                {method.name}
                                {method.popular && (
                                  <span className="er-method-badge">
                                    Popular
                                  </span>
                                )}
                              </span>
                              <span className="er-method-sub">
                                {method.sub}
                              </span>
                            </span>

                            <span
                              className="er-method-chevron"
                              aria-hidden="true"
                            >
                              <svg
                                viewBox="0 0 24 24"
                                width="18"
                                height="18"
                                fill="none"
                              >
                                <path
                                  d="M9 6l6 6-6 6"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </button>
                        ))}
                      </div>

                      {paymentMethod === "vnpay" && (
                        <div className="er-payment-method-panel">
                          <div className="er-info-note">
                            <svg
                              viewBox="0 0 24 24"
                              width="14"
                              height="14"
                              fill="none"
                            >
                              <circle
                                cx="12"
                                cy="12"
                                r="9"
                                stroke="currentColor"
                                strokeWidth="1.6"
                              />
                              <path
                                d="M12 8h.01M11 12h1v4h1"
                                stroke="currentColor"
                                strokeWidth="1.6"
                                strokeLinecap="round"
                              />
                            </svg>
                            <span>
                              Pay using your PayPal account or supported debit
                              and credit cards.
                            </span>
                          </div>

                          {vnpayError && (
                            <div className="er-error">{vnpayError}</div>
                          )}

                          <button
                            type="button"
                            className="er-pay-btn er-pay-btn--dark"
                            onClick={handleVNPayPayment}
                            disabled={vnpayLoading || !orderId || totalVND <= 0}
                          >
                            <svg
                              viewBox="0 0 24 24"
                              width="18"
                              height="18"
                              fill="none"
                            >
                              <rect
                                x="2.5"
                                y="6"
                                width="19"
                                height="12"
                                rx="2"
                                stroke="currentColor"
                                strokeWidth="1.6"
                              />
                              <path
                                d="M2.5 10h19"
                                stroke="currentColor"
                                strokeWidth="1.6"
                              />
                            </svg>
                            {vnpayLoading
                              ? "Waiting for payment…"
                              : `Pay $${totalUSD.toFixed(2)} with VNPAY`}
                            <svg
                              viewBox="0 0 24 24"
                              width="16"
                              height="16"
                              fill="none"
                            >
                              <path
                                d="M5 12h14M13 6l6 6-6 6"
                                stroke="currentColor"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </button>
                        </div>
                      )}

                      {paymentMethod === "paypal" && (
                        <div className="er-payment-method-panel">
                          {paymentConfirmed ? (
                            <div className="er-payment-confirmed-banner">
                              <div>Payment received via PayPal.</div>
                              <p>
                                Order ID: <strong>{orderId}</strong>
                              </p>
                              <button
                                type="button"
                                className="er-continue-btn"
                                onClick={() => {
                                  setPaymentResult("success");
                                  setShowSuccessPopup(true);
                                }}
                              >
                                Continue to Registration →
                              </button>
                            </div>
                          ) : (
                            <>
                              <div className="er-info-note">
                                <svg
                                  viewBox="0 0 24 24"
                                  width="14"
                                  height="14"
                                  fill="none"
                                >
                                  <circle
                                    cx="12"
                                    cy="12"
                                    r="9"
                                    stroke="currentColor"
                                    strokeWidth="1.6"
                                  />
                                  <path
                                    d="M12 8h.01M11 12h1v4h1"
                                    stroke="currentColor"
                                    strokeWidth="1.6"
                                    strokeLinecap="round"
                                  />
                                </svg>
                                <span>
                                  You will be redirected to PayPal to complete
                                  payment securely.
                                </span>
                              </div>

                              {error && <div className="er-error">{error}</div>}

                              <button
                                type="button"
                                className="er-pay-btn er-pay-btn--dark"
                                onClick={handlePayPalClick}
                                disabled={isPaying || !orderId}
                              >
                                {isPaying
                                  ? "Redirecting…"
                                  : `Pay $${totalUSD.toFixed(2)} with PayPal`}
                                <svg
                                  viewBox="0 0 24 24"
                                  width="16"
                                  height="16"
                                  fill="none"
                                >
                                  <path
                                    d="M5 12h14M13 6l6 6-6 6"
                                    stroke="currentColor"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </button>
                            </>
                          )}
                        </div>
                      )}

                      {paymentMethod === "bank" && (
                        <div className="er-payment-method-panel">
                          {paymentConfirmed ? (
                            <div className="er-payment-confirmed-banner">
                              <div>We've recorded your bank transfer.</div>
                              <p>
                                Order ID: <strong>{orderId}</strong>
                              </p>
                              <button
                                type="button"
                                className="er-continue-btn"
                                onClick={() => {
                                  setPaymentResult("success");
                                  setShowSuccessPopup(true);
                                }}
                              >
                                Continue to Registration →
                              </button>
                            </div>
                          ) : (
                            <>
                              <div className="er-bank-currency-row">
                                <div className="er-bank-currency-card">
                                  <div className="er-bank-currency-label">
                                    Amount (USD)
                                  </div>
                                  <div className="er-bank-currency-amount">
                                    ${totalUSD.toFixed(2)}
                                  </div>
                                </div>
                                <div className="er-bank-currency-card">
                                  <div className="er-bank-currency-label">
                                    Amount (EUR)
                                  </div>
                                  <div className="er-bank-currency-amount">
                                    €{totalEUR}
                                  </div>
                                </div>
                              </div>

                              <div className="er-bank-details-table">
                                <div className="er-bank-details-row">
                                  <span>Account Name</span>
                                  <span>{BANK_DETAILS.accountName}</span>
                                </div>
                                <div className="er-bank-details-row">
                                  <span>Bank Name</span>
                                  <span>{BANK_DETAILS.bankName}</span>
                                </div>
                                <div className="er-bank-details-row">
                                  <span>USD Account</span>
                                  <span>{BANK_DETAILS.accountNumberUSD}</span>
                                </div>
                                <div className="er-bank-details-row">
                                  <span>EUR Account</span>
                                  <span>{BANK_DETAILS.accountNumberEUR}</span>
                                </div>
                                <div className="er-bank-details-row">
                                  <span>SWIFT / BIC</span>
                                  <span>{BANK_DETAILS.swiftCode}</span>
                                </div>
                                <div className="er-bank-details-row">
                                  <span>IBAN</span>
                                  <span>{BANK_DETAILS.iban}</span>
                                </div>
                                <div className="er-bank-details-row">
                                  <span>Order ID</span>
                                  <span>{orderId}</span>
                                </div>
                              </div>

                              {error && <div className="er-error">{error}</div>}

                              <button
                                type="button"
                                className="er-pay-btn er-pay-btn--dark"
                                onClick={handleBankClick}
                                disabled={isPaying || !orderId}
                              >
                                {isPaying
                                  ? "Recording…"
                                  : "I've Made the Transfer"}
                              </button>
                            </>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Trust strip */}
            <div className="er-trust-footer">
              <div className="er-trust-item">
                <svg
                  className="er-trust-icon"
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                >
                  <rect
                    x="5"
                    y="11"
                    width="14"
                    height="9"
                    rx="2"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  />
                  <path
                    d="M8 11V7a4 4 0 0 1 8 0v4"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                </svg>
                <div className="er-trust-text">
                  <span className="er-trust-title">Secure Payment</span>
                  <span className="er-trust-sub">
                    Your payment is fully encrypted.
                  </span>
                </div>
              </div>

              <div className="er-trust-item">
                <svg
                  className="er-trust-icon"
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  />
                  <path
                    d="M8 12.5l2.5 2.5L16 9.5"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="er-trust-text">
                  <span className="er-trust-title">Instant Confirmation</span>
                  <span className="er-trust-sub">
                    Confirmed as soon as payment clears.
                  </span>
                </div>
              </div>

              <div className="er-trust-item">
                <svg
                  className="er-trust-icon"
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  />
                  <path
                    d="M9.5 9.2a2.5 2.5 0 1 1 3.5 2.3c-.8.4-1 .9-1 1.6"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                  <circle cx="12" cy="17" r="0.9" fill="currentColor" />
                </svg>
                <div className="er-trust-text">
                  <span className="er-trust-title">Need Help?</span>
                  <span className="er-trust-sub">
                    Contact our support team anytime.
                  </span>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* ================= VERIFYING OVERLAY ================= */}
      {vnpayLoading && !showSuccessPopup && (
        <div className="er-verifying-overlay">
          <div className="er-verifying-box">
            <div className="er-verifying-spinner" />
            <h3>Verifying your payment…</h3>
            <p>
              Complete your payment in the VNPay window. This will update
              automatically once it's done.
            </p>
            <div className="er-verifying-actions">
              <button
                type="button"
                className="er-verifying-recheck-btn"
                onClick={handleManualStatusCheck}
              >
                Check Status Now
              </button>
              <button
                type="button"
                className="er-verifying-cancel-btn"
                onClick={handleClosePaymentPopup}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= SUCCESS / REJECTED POPUP ================= */}
      {showSuccessPopup && (
        <div
          className="registration-success-overlay"
          onClick={handleClosePaymentPopup}
        >
          <div
            className={`registration-success-modal ${
              paymentResult === "rejected"
                ? "payment-rejected-modal"
                : "payment-success-modal"
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            {paymentResult === "rejected" && (
              <button
                type="button"
                className="payment-popup-close"
                onClick={handleClosePaymentPopup}
                aria-label="Close"
              >
                ×
              </button>
            )}

            <div
              className={`success-icon ${
                paymentResult === "rejected" ? "rejected-icon" : ""
              }`}
            >
              {paymentResult === "rejected" ? "!" : "✓"}
            </div>

            <h2>
              {paymentResult === "rejected"
                ? "Payment Rejected"
                : isFreeRegistration
                  ? "Registration Confirmed!"
                  : "Payment Successful!"}
            </h2>

            <p>
              {paymentResult === "rejected" ? (
                <>
                  Unfortunately, your payment for <strong>{eventTitle}</strong>{" "}
                  was rejected. Close this and pay again to complete your
                  registration.
                </>
              ) : (
                <>
                  Your registration for <strong>{eventTitle}</strong> is now
                  confirmed.
                </>
              )}
            </p>

            {paymentResult === "rejected" && vnpayError && (
              <div className="payment-rejected-message">{vnpayError}</div>
            )}

            <div className="success-user-info">
              <div>
                <span>Order ID</span>
                <strong>{orderId || "—"}</strong>
              </div>
              <div>
                <span>Registration ID</span>
                <strong>{registrationId || "—"}</strong>
              </div>
              <div>
                <span>Event</span>
                <strong>{eventTitle}</strong>
              </div>
              <div>
                <span>Name</span>
                <strong>
                  {title} {firstName} {lastName}
                </strong>
              </div>
              <div>
                <span>Email</span>
                <strong>{email || "—"}</strong>
              </div>
              <div>
                <span>Amount</span>
                <strong>{isFreeRegistration ? "FREE" : formattedUSD}</strong>
              </div>
              <div>
                <span>Payment Status</span>
                <strong>
                  {paymentResult === "rejected"
                    ? "REJECTED"
                    : isFreeRegistration
                      ? "FREE"
                      : "PAID"}
                </strong>
              </div>
            </div>

            {paymentResult !== "rejected" && email && (
              <div className="success-message">
                A confirmation email will be sent to <strong>{email}</strong>.
              </div>
            )}

            {paymentResult === "rejected" ? (
              <div className="payment-popup-actions">
                <button
                  type="button"
                  className="proceed-payment-btn"
                  onClick={handleClosePaymentPopup}
                >
                  Close &amp; Pay Again
                </button>
              </div>
            ) : (
              <div className="payment-popup-actions">
                <button
                  type="button"
                  className="proceed-payment-btn"
                  onClick={handleContinueAfterPayment}
                >
                  Done
                </button>

                {!isFreeRegistration && (
                  <button
                    type="button"
                    className="invoice-download-btn"
                    onClick={handleDownloadInvoice}
                  >
                    Download Invoice
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentView;
